var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetingroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199,
    height: 199,
    viewBox: "0 0 199 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 158.341,
    height: 108.535,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 158.313,
    height: 108.535,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 199,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 198,
    height: 198,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(22.659 43.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M558.312,175.528a8.734,8.734,0,0,1,.48-2.122,5.513,5.513,0,0,0,.323-2.143c-.118-1.135-.87-2.172-.785-3.309a1.452,1.452,0,0,1,.584-1.13,1.4,1.4,0,0,1,1.478.095,4.289,4.289,0,0,1,1.5,2.227,7.96,7.96,0,0,1-.012,2.16c-.182,1.884.247,3.337.064,5.221a1.51,1.51,0,0,1-.089.446c-.124.294-1.455.5-1.767.565-1.312.29-1.824-.85-1.774-2.01",
    transform: "translate(-425.838 -127.11)",
    fill: "#3c2f9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M523.75,202.659l3.642.186,1.794.583a4.626,4.626,0,0,1,2.384,1.784c.645.94,1.619,2.495,3.007,5.021l5.731-3.671,1.207.633s-6.021,5.673-6.757,6.081a1.115,1.115,0,0,1-1.491-.395l-2.81-4.579c-3.559,9.2-2.067,12.68-2.067,12.68h-8.1V208.733l-2.511,4.088a3.239,3.239,0,0,1-2.208,1.5l-6.894,1.192-.379-1.149s.983-.305,5.916-1.932a3.249,3.249,0,0,0,1.835-1.529,53.051,53.051,0,0,1,3.606-5.938,3.415,3.415,0,0,1,1.359-1.087Z",
    transform: "translate(-387.692 -154.574)",
    fill: "#97d8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M498.239,250.119l-3.166-.807a.611.611,0,0,1-.061-1.165c.608-.229,1.529-.177,2.848.823Z",
    transform: "translate(-377.256 -189.184)",
    fill: "#d2cbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M573.428,189.863s-.109.653,1.227.653a5.059,5.059,0,0,0,2.4-.653V185.64h-3.623Z",
    transform: "translate(-437.368 -141.593)",
    fill: "#d2cbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M573.435,197.608V196.7a2.869,2.869,0,0,0,.5.043,3.6,3.6,0,0,0,1.144-.2,4.58,4.58,0,0,0,.2.42,3.848,3.848,0,0,1-1.84.645",
    transform: "translate(-437.375 -149.909)",
    fill: "#8fb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M570.44,157.384v2.246h-.688v3.107s-2.261,2.158-4.39,1.082a2.924,2.924,0,0,1-1.5-2.634v-3.8a3.905,3.905,0,0,1,.426-1.791,3.187,3.187,0,0,1,2.8-1.822h.121a3.438,3.438,0,0,1,3.23,3.613",
    transform: "translate(-430.071 -117.286)",
    fill: "#d2cbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M496.982,239.655h-3.189a.158.158,0,0,1-.159-.158v-.46a.159.159,0,0,1,.159-.159h3.189a.159.159,0,0,1,.159.159v.46a.158.158,0,0,1-.159.158",
    transform: "translate(-376.509 -182.199)",
    fill: "#5f64ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M497.72,246.436h-1.955l-.354-4.283h2.663Z",
    transform: "translate(-377.864 -184.697)",
    fill: "#3e29a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M499.379,247.848a.742.742,0,1,1-.742-.742.742.742,0,0,1,.742.742",
    transform: "translate(-379.759 -188.475)",
    fill: "#524fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(0.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M495.495,247.85l-.354-.025a.593.593,0,0,0-.494.2,1.047,1.047,0,0,0-.239.55.6.6,0,0,0,.672.646,1.8,1.8,0,0,0,.69-.24.611.611,0,0,0-.274-1.132",
    transform: "translate(-377.124 -189.022)",
    fill: "#d2cbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M629.486,192.22l-2.319-3.09a1.025,1.025,0,0,1,.2-1.435l5.212-3.911a1.025,1.025,0,0,1,1.435.2l2.319,3.09a1.025,1.025,0,0,1-.2,1.435l-5.212,3.911a1.025,1.025,0,0,1-1.435-.2",
    transform: "translate(-478.23 -140.021)",
    fill: "#2b2c2f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M631.484,193.4l-2.584-3.444a.382.382,0,0,1,.076-.535l5.349-4.014a.382.382,0,0,1,.535.076l2.584,3.444a.383.383,0,0,1-.076.535l-5.349,4.014a.382.382,0,0,1-.535-.076",
    transform: "translate(-479.621 -141.353)",
    fill: "#5cfdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M633.294,212.381a.153.153,0,1,1,.03-.214.153.153,0,0,1-.03.214",
    transform: "translate(-482.844 -161.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    width: 0.682,
    height: 4.17,
    transform: "translate(154.337 44.884) rotate(-36.902)",
    fill: "#555457"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 1.055,
    height: 4.169,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 150.442, 47.809)",
    fill: "#555457"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_419",
    "data-name": "Rectangle 419",
    width: 0.269,
    height: 4.17,
    transform: "translate(151.989 46.648) rotate(-36.904)",
    fill: "#555457"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_420",
    "data-name": "Rectangle 420",
    width: 0.269,
    height: 4.169,
    transform: "translate(151.53 46.992) rotate(-36.904)",
    fill: "#555457"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 2.057,
    height: 4.17,
    transform: "translate(152.448 46.303) rotate(-36.902)",
    fill: "#555457"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 0.806,
    height: 0.84,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 153.431, 45.786)",
    fill: "#5f64ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 0.806,
    height: 0.84,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 152.678, 46.352)",
    fill: "#83a6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    width: 0.806,
    height: 0.84,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 154.024, 46.576)",
    fill: "#8cd6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 0.806,
    height: 0.84,
    transform: "translate(153.271 47.142) rotate(-36.905)",
    fill: "#3c2f9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    width: 0.806,
    height: 0.84,
    transform: "translate(154.624 47.376) rotate(-36.896)",
    fill: "#83a6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 0.806,
    height: 0.84,
    transform: "translate(153.871 47.941) rotate(-36.893)",
    fill: "#5f64ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    width: 0.806,
    height: 0.84,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 155.217, 48.165)",
    fill: "#3c2f9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_429",
    "data-name": "Rectangle 429",
    width: 0.806,
    height: 0.84,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 154.464, 48.731)",
    fill: "#8cd6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    width: 0.806,
    height: 0.84,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 151.552, 51.139)",
    fill: "#5f64ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    width: 0.806,
    height: 0.84,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 149.553, 48.477)",
    fill: "#3c2f9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    width: 0.806,
    height: 0.84,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 150.219, 49.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    width: 0.806,
    height: 0.84,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 150.885, 50.252)",
    fill: "#83a6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M634.549,202.976l-.154-.206.154.206Zm7.11-2.941-.059-.078.059.078",
    transform: "translate(-483.871 -152.512)",
    fill: "#839297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M633.941,201.755l-.154-.206-.189-.252.279-.116.11.146.568-.426.383-.159.344.458-.291.121-.2-.262-.645.484.072.1-.28.116m2.347-.971-.344-.458.291-.121.344.458-.292.121m.548-.227-.344-.458.291-.121.344.458-.291.121m.548-.227-.344-.458.292-.121.344.458-.291.121m2.254-.932-.344-.458.292-.121.344.458-.291.121m.942-.39-.344-.458.471-.195.285.38.059.078-.471.195",
    transform: "translate(-483.262 -151.292)",
    fill: "#d1e8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M659.176,199.9l-.344-.458.651-.269.344.458Z",
    transform: "translate(-502.51 -151.918)",
    fill: "#9ca5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M639.589,207.534l-.344-.458,1.007-.416.344.458Z",
    transform: "translate(-487.57 -157.625)",
    fill: "#9ca5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M647.368,205.314l-.344-.458.256-.106.344.458Z",
    transform: "translate(-493.504 -156.169)",
    fill: "#9ca5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M645.06,206.269l-.344-.458.256-.106.344.458Z",
    transform: "translate(-491.743 -156.897)",
    fill: "#9ca5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M649.677,202.09l-.344-.458.147-.061.16.213.645-.484-.036-.047.129-.054.015.02.076-.057.546-.226-.534.4.241.321-.13.053-.22-.293-.644.484.1.127Zm1.815-.751-.344-.458.147-.061.344.458-.147.061",
    transform: "translate(-495.265 -153.171)",
    fill: "#9ca5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M653.755,202.317l-.015-.02.091-.037Z",
    transform: "translate(-498.626 -154.269)",
    fill: "#fdc4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M650.113,203.175l-.16-.213.769-.318.036.047Z",
    transform: "translate(-495.738 -154.562)",
    fill: "#ff9857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M654.415,201.853l-.241-.321.534-.4.133-.055.344.458Z",
    transform: "translate(-498.957 -153.367)",
    fill: "#8395ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M651.1,203.951l-.1-.127.644-.484.22.293Z",
    transform: "translate(-496.537 -155.093)",
    fill: "#e7e6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M634.884,209.51l-.11-.146.678-.28Z",
    transform: "translate(-484.16 -159.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M635.991,210.33l-.072-.1.645-.484.2.262Z",
    transform: "translate(-485.034 -159.982)",
    fill: "#fdc4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M630.04,196.558l-.746-.994.279-.116.465.619.645-.484-.34-.453.291-.121.746.994-.292.121-.244-.325-.645.484.12.16Zm2.347-.971-.746-.994.292-.121.746.994-.291.121m.548-.227-.746-.994.291-.121.746.994-.291.121m.548-.227-.746-.994.291-.121.746.994-.292.121m2.254-.932-.746-.994.291-.121.746.994-.291.121m.943-.39-.746-.994.471-.2.061.081.685.913-.471.195",
    transform: "translate(-479.981 -146.919)",
    fill: "#d1e8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M655.273,194.708l-.746-.994.651-.269.746.994Z",
    transform: "translate(-499.226 -147.546)",
    fill: "#9ca5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M635.687,202.338l-.746-.994,1.007-.416.746.994Z",
    transform: "translate(-484.288 -153.253)",
    fill: "#9ca5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M643.466,200.118l-.746-.994.256-.106.746.994Z",
    transform: "translate(-490.221 -151.797)",
    fill: "#9ca5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M641.158,201.073l-.746-.994.256-.106.746.994Z",
    transform: "translate(-488.46 -152.525)",
    fill: "#9ca5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M645.774,196.894l-.746-.994.62-.256-.4.3.5.672.645-.484-.456-.608.129-.054.435.58.645-.484-.311-.414.147-.061.746.994-.147.061-.339-.452-.645.484.215.286-.129.054-.194-.258-.644.484.069.092Z",
    transform: "translate(-491.981 -148.799)",
    fill: "#9ca5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M649.871,196.243l-.435-.58.769-.318.311.414Z",
    transform: "translate(-495.343 -148.995)",
    fill: "#e7e6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M646.475,198l-.5-.672.4-.3.3-.123.456.608Z",
    transform: "translate(-492.7 -150.19)",
    fill: "#8395ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M651.891,198.4l-.215-.286.645-.484.339.452Z",
    transform: "translate(-497.052 -150.737)",
    fill: "#fdc4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M648.572,200.589l-.069-.092.644-.484.194.258Z",
    transform: "translate(-494.632 -152.556)",
    fill: "#ff9857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M630.935,204.128l-.465-.619.769-.318.34.453Z",
    transform: "translate(-480.877 -154.98)",
    fill: "#8395ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M633.231,206.653l-.12-.16.645-.484.244.325Z",
    transform: "translate(-482.892 -157.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M642.825,211.447l2.24-3.036a.387.387,0,0,1,.669.078c.267.659.322,1.837-1.7,3.04Z",
    transform: "translate(-490.301 -158.841)",
    fill: "#d2cbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M592.605,252.764h0Zm0,0s-.008-.018-.018-.047c.01.029.017.045.018.047m-.117-4.867v0a28.833,28.833,0,0,1,.765-3.566h0a28.872,28.872,0,0,0-.765,3.569",
    transform: "translate(-451.908 -186.355)",
    fill: "#fbe3d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M589.786,264.227h0Zm.011-.047a10.678,10.678,0,0,1-.1-4.823v0a10.688,10.688,0,0,0,.1,4.82",
    transform: "translate(-449.117 -197.818)",
    fill: "#efcec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M588.817,252.451h-.985s-1.035-2.414.674-8.534l.023.007a2.276,2.276,0,0,0,.65.1,1.978,1.978,0,0,0,.236-.014l.048.005a28.822,28.822,0,0,0-.765,3.566,10.677,10.677,0,0,0,.1,4.824c.01.029.017.045.018.047Z",
    transform: "translate(-448.119 -186.042)",
    fill: "#6ccbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M578.564,170.674a6.193,6.193,0,0,0,.679-3.44c-.306-1.3-1.535-2.137-2.258-3.257a4.617,4.617,0,0,1-.511-3.848,4.681,4.681,0,0,0,.543-2.428,3.53,3.53,0,0,0-1.257-1.607,2.276,2.276,0,0,1-.951-1.755,1.609,1.609,0,0,1,1.016-1.246,3.68,3.68,0,0,1,1.66-.2,2.955,2.955,0,0,1,2.43,1.074c.66,1.055,0,2.467.331,3.665a5.528,5.528,0,0,0,1.995,2.377,8.363,8.363,0,0,1,2.23,2.924,4.971,4.971,0,0,1,.188,3.616c-.391,1.067-1.212,1.932-1.631,2.988a15.419,15.419,0,0,0-.56,2.379c-.326,1.47-1.4,3.093-3.158,2.572-1.58-.469-1.163-2.667-.745-3.811",
    transform: "translate(-438.419 -116.603)",
    fill: "#3c2f9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M560.214,154.416c-.1.269-.182.584-.438.711a.731.731,0,0,1-.684-.091,1.8,1.8,0,0,1-.757-1.827,2.514,2.514,0,0,1,1.033-1.691,4.424,4.424,0,0,1,1.7-.832,4.8,4.8,0,0,1,1.96-.058,2.43,2.43,0,0,1,1.625,1.182,1.5,1.5,0,0,1-.44,1.652c-.472.388-.731.242-1.142-.086a1.845,1.845,0,0,0-2.862,1.039",
    transform: "translate(-425.838 -114.829)",
    fill: "#3c2f9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M587.382,213.526c-1.552-.484-1.138-2.665-.722-3.8a6.2,6.2,0,0,0,.68-3.44,4.935,4.935,0,0,0-1.292-2.06c.135-.053.252-.1.346-.15a12.468,12.468,0,0,1,.872,1.048h0l0,0,0,0,0,0,0,.007v0l0,.006,0,0,0,.007h0l.011.017a3.312,3.312,0,0,1,.506,1.067h0l.005.02h0l0,.008v0l0,.009a2.817,2.817,0,0,1,.074.651,8.53,8.53,0,0,1-.753,2.789,6.074,6.074,0,0,0-.382,1.964,1.889,1.889,0,0,0,.681,1.638l-.057.2",
    transform: "translate(-446.995 -155.652)",
    fill: "#6bcaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M582.344,198.957h0c-.1-.116-.206-.231-.307-.348a7.493,7.493,0,0,1-.658-.848q-.1-.156-.187-.319a3.5,3.5,0,0,0,.347-.272,4.449,4.449,0,0,0,.248.476v0l0,0,0,0h0c.022.036.044.071.066.106l0,.007h0l0,.007a8.872,8.872,0,0,0,.823,1.032c-.095.046-.211.1-.346.15",
    transform: "translate(-443.292 -150.386)",
    fill: "#8fb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M580.565,196.439a4.566,4.566,0,0,1-.2-.42c.144-.049.283-.1.416-.163q.057.158.125.312a3.5,3.5,0,0,1-.347.272",
    transform: "translate(-442.665 -149.384)",
    fill: "#789fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M574.722,169.337h0a4.652,4.652,0,0,1-.26-2.586,4.38,4.38,0,0,1,.13-.521,4.683,4.683,0,0,0,.543-2.428,3.534,3.534,0,0,0-1.257-1.607,2.868,2.868,0,0,1-.914-1.3,1.565,1.565,0,0,1,.258-.021,1.527,1.527,0,0,1,.22.016,2.69,2.69,0,0,0,.809,1.205h0l.1.1a3.53,3.53,0,0,1,1.257,1.607,1.69,1.69,0,0,1,.047.4,7.176,7.176,0,0,1-.59,2.026,4.621,4.621,0,0,0,.066,2.945c-.133.06-.272.115-.416.163",
    transform: "translate(-437.017 -122.703)",
    fill: "#8fb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M592.345,243.371a2.276,2.276,0,0,1-.65-.1l-.023-.007.057-.2a1.553,1.553,0,0,0,.446.21,2.425,2.425,0,0,0,.407.085,1.984,1.984,0,0,1-.236.014",
    transform: "translate(-451.284 -185.39)",
    fill: "#63c0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M579.849,180.72a2.425,2.425,0,0,1-.407-.085,2.391,2.391,0,0,0,.412.084h-.006m-1.533-1.933a6.072,6.072,0,0,1,.382-1.964,8.528,8.528,0,0,0,.753-2.789,8.528,8.528,0,0,1-.753,2.789,6.072,6.072,0,0,0-.382,1.964m1.059-5.413v0m0-.01h0m-.005-.021h0m-.506-1.068h0m-.011-.017h0m-.005-.008,0,0,0,0m-.006-.008v0m-.006-.009,0,0,0,0m0-.007,0,0,0,0m0-.006a12.447,12.447,0,0,0-.872-1.048,8.874,8.874,0,0,1-.823-1.032,7.726,7.726,0,0,0,.671.86l.152.173a12.447,12.447,0,0,1,.872,1.048m-1.694-2.08,0-.007,0,.007m0-.007,0-.007,0,.007m-.071-.113h0m0,0,0,0,0,0m0-.005a4.437,4.437,0,0,1-.248-.476q-.068-.153-.125-.312a4.621,4.621,0,0,1-.066-2.945,7.176,7.176,0,0,0,.59-2.026,7.176,7.176,0,0,1-.59,2.026,4.417,4.417,0,0,0-.131.521,4.662,4.662,0,0,0,.2,2.424,4.468,4.468,0,0,0,.373.788m-1.257-7.864h0m0,0a2.69,2.69,0,0,1-.809-1.205h0a2.69,2.69,0,0,0,.808,1.205",
    transform: "translate(-438.552 -122.754)",
    fill: "#43278e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M577.8,360.928h.005c2.685,3.923,4.334,6.522,6.982,10.022a1.347,1.347,0,0,0,2.422-.9l0-.03a7.52,7.52,0,0,0-1.235-2.717A70.019,70.019,0,0,1,583,360.378c-1.025-2.3-2.31-4.964-4.579-6.04-.061.244-.112.488-.159.731-.346,1.925-.24,3.911-.462,5.86",
    transform: "translate(-440.703 -270.263)",
    fill: "#485498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M554.559,297.464c-.6,6.614-1.247,13.222-2.5,20.136l2.864-.343c.127-4.376,2.6-8.364,3.2-12.7q.032-.209.049-.415c.222-1.948.116-3.934.462-5.86.046-.243.1-.486.159-.731a28.16,28.16,0,0,1,2.288-5.686,17.27,17.27,0,0,0,1.971-5.37,8.511,8.511,0,0,0-1.278-6.609h-8.1c-1.343,5.565-2.04,12.456.895,17.58",
    transform: "translate(-421.069 -213.476)",
    fill: "#5d5fcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M558.591,344.589l-.008-.013.008.013m-.01-.018,0-.007,0,.007m-1.009-2.207q-.124-.345-.23-.7c.071.234.148.466.23.7",
    transform: "translate(-425.101 -260.601)",
    fill: "#6a9eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M558.577,317.986h0l-.008-.013,0,0,0-.007a14.106,14.106,0,0,1-1.005-2.2q-.123-.344-.23-.7l0-.015.243-.837h1.371q-.189,1.891-.361,3.772m.615-6.257h-.9l1.432-4.939q-.271,2.48-.528,4.939",
    transform: "translate(-425.087 -233.998)",
    fill: "#4137e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M540.212,442.434a.194.194,0,0,1-.161.2l-7.817,1.352a.2.2,0,0,1-.22-.144c-.016-.068-.031-.137-.042-.206l8.228-1.423h0c0,.074.008.147.011.221",
    transform: "translate(-405.75 -337.289)",
    fill: "#84b5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M540.153,435.6h0l-8.228,1.423a1.119,1.119,0,0,1,.012-.431.643.643,0,0,1,.114-.242c.274-.349.73-.207,1.122-.264a2.138,2.138,0,0,0,.893-.438,30.136,30.136,0,0,0,2.56-2.04.254.254,0,0,1,.326-.013.642.642,0,0,1,.135.151c.029.046.056.095.083.142h0a1.186,1.186,0,0,0,.144.217.923.923,0,0,0,.537.259,1.778,1.778,0,0,0,1.364-.355c.051-.04.1-.083.145-.128a.331.331,0,0,1,.456-.018.459.459,0,0,1,.066.075,1.047,1.047,0,0,1,.145.421,10.422,10.422,0,0,1,.125,1.24",
    transform: "translate(-405.702 -330.672)",
    fill: "#5f64ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M603.13,422.528a.193.193,0,0,1-.024.255l-5.787,5.426a.2.2,0,0,1-.263,0c-.051-.048-.1-.1-.148-.15L603,422.35h0l.13.179",
    transform: "translate(-455.279 -322.138)",
    fill: "#84b5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M602.146,418.266h0l-6.091,5.711a1.113,1.113,0,0,1-.227-.367.639.639,0,0,1-.037-.265c.037-.442.5-.574.792-.837a2.133,2.133,0,0,0,.506-.857,30.1,30.1,0,0,0,1.017-3.112.254.254,0,0,1,.265-.191.642.642,0,0,1,.2.052c.05.023.1.048.148.073h0a1.177,1.177,0,0,0,.239.1.92.92,0,0,0,.591-.079,1.776,1.776,0,0,0,.944-1.046,1.92,1.92,0,0,0,.051-.186.331.331,0,0,1,.371-.266.437.437,0,0,1,.1.026,1.052,1.052,0,0,1,.352.272,10.463,10.463,0,0,1,.786.968",
    transform: "translate(-454.424 -318.055)",
    fill: "#5f64ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M509.442,235.991h0l-.14-.425c2.133-.5,7.143-1.153,8.1-1.945,1.388-1.145,2.054-3.008,3.467-4.109l-2.328,3.791a3.239,3.239,0,0,1-2.208,1.5Z",
    transform: "translate(-388.459 -175.055)",
    fill: "#6ccbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M612.419,226.867h0Zm0,0a1.1,1.1,0,0,0,.537-.14c.7-.39,6.234-5.589,6.722-6.049-.489.46-6.02,5.658-6.722,6.049a1.1,1.1,0,0,1-.537.14m-1.049-5.657-.079-.134.079.134m-.081-.137v0m-.458-.761-.01-.017.01.017",
    transform: "translate(-465.89 -168.025)",
    fill: "#fbe3d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M609.282,226.867h0a1.118,1.118,0,0,1-.951-.534l-1.621-2.641q.041-.134.073-.267.011-.045.021-.09a15.419,15.419,0,0,1,.56-2.379,5.62,5.62,0,0,1,.322-.661l.01.017q.216.352.457.759v0l0,0,.079.134a3.406,3.406,0,0,0,.37,4.174,1.032,1.032,0,0,0,.438.311.663.663,0,0,0,.191.027,1.412,1.412,0,0,0,.582-.165,11.1,11.1,0,0,0,3.347-2.8,26.418,26.418,0,0,1,2.129-2.222,1.011,1.011,0,0,0,.091-.048l-.105.143,1.207.082.057-.034c-.489.46-6.02,5.658-6.722,6.049a1.1,1.1,0,0,1-.537.14Z",
    transform: "translate(-462.753 -168.025)",
    fill: "#6ccbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M642.884,220.894l.153-.132-.062.084a1.028,1.028,0,0,1-.091.048",
    transform: "translate(-490.346 -168.381)",
    fill: "#2a2165"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M644.032,220.379l-1.207-.082.105-.143.062-.084q.129-.11.262-.215l.869.456-.034.033-.057.034",
    transform: "translate(-490.301 -167.69)",
    fill: "#7cbdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M606.707,233.754h0c.027-.089.052-.178.073-.267q-.032.133-.073.267",
    transform: "translate(-462.753 -178.087)",
    fill: "#3e2369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M569.193,187.048a1.463,1.463,0,0,1-2.889,0Z",
    transform: "translate(-431.936 -142.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M569.2,174.882a.482.482,0,0,1-.543-.329.541.541,0,0,1,.005-.36,1.6,1.6,0,0,1,.157-.3,1.656,1.656,0,0,0,.244-1.171,1.179,1.179,0,0,1,.123.638,1.331,1.331,0,0,1-.216.628.689.689,0,0,0-.18.523.472.472,0,0,0,.41.366",
    transform: "translate(-433.712 -131.744)",
    fill: "#7289f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 0.705,
    height: 13.44,
    transform: "translate(143.512 91.834)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M643.189,364.606h1.771a1.605,1.605,0,0,0,1.6-1.6v-2.04h-.705V363a.9.9,0,0,1-.9.9h-1.771Z",
    transform: "translate(-490.579 -275.317)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M567.2,372.156h16.723a1.209,1.209,0,1,0,0-2.418H567.2a1.209,1.209,0,0,0,0,2.418",
    transform: "translate(-431.7 -282.01)",
    fill: "#97d8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M599.26,385.171h1.083a1.489,1.489,0,0,0,1.488-1.489v-.2h-4.06v.2a1.489,1.489,0,0,0,1.488,1.489",
    transform: "translate(-455.938 -292.493)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M590.544,380.772H579.369a1.09,1.09,0,0,1-1.061-.844h13.3a1.091,1.091,0,0,1-1.061.844",
    transform: "translate(-441.092 -289.782)",
    fill: "#4048b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M653.249,301.269V284.546a1.209,1.209,0,0,0-2.418,0v16.723a1.209,1.209,0,1,0,2.418,0",
    transform: "translate(-496.407 -216.109)",
    fill: "#4048b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M642.627,288.432v16.723s-2.552-1.142-2.552-8.361,2.552-8.361,2.552-8.361",
    transform: "translate(-488.203 -219.995)",
    fill: "#97d8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M602.86,414.81h1.646v-8.648a.335.335,0,0,0-.335-.335H603.2a.335.335,0,0,0-.335.335Z",
    transform: "translate(-459.818 -309.536)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M599.906,441.418h3.047v-.049a.656.656,0,0,0-.656-.656h-1.736a.656.656,0,0,0-.656.656Z",
    transform: "translate(-457.565 -336.144)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M573.671,445.1h15.5v-.755a.656.656,0,0,0-.656-.656H574.327a.656.656,0,0,0-.656.656Z",
    transform: "translate(-437.555 -338.411)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 0.705,
    height: 13.44,
    transform: "translate(46.398 91.822)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M174.631,372.108H157.908a1.209,1.209,0,0,1,0-2.418h16.723a1.209,1.209,0,1,1,0,2.418",
    transform: "translate(-119.519 -281.973)",
    fill: "#97d8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M191.05,385.124h-1.083a1.489,1.489,0,0,1-1.489-1.489v-.2h4.06v.2a1.489,1.489,0,0,1-1.488,1.489",
    transform: "translate(-143.758 -292.458)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M170.075,380.724H181.25a1.091,1.091,0,0,0,1.061-.844h-13.3a1.091,1.091,0,0,0,1.061.844",
    transform: "translate(-128.912 -289.745)",
    fill: "#4048b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M195.212,414.762h-1.645v-8.648a.335.335,0,0,1,.335-.335h.975a.335.335,0,0,1,.335.335Z",
    transform: "translate(-147.639 -309.499)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M193.66,441.37h-3.048v-.049a.656.656,0,0,1,.656-.656H193a.656.656,0,0,1,.656.656Z",
    transform: "translate(-145.385 -336.108)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M179.874,445.047h-15.5v-.755a.656.656,0,0,1,.656-.656h14.185a.656.656,0,0,1,.656.656Z",
    transform: "translate(-125.375 -338.375)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M175.274,296.767a1.661,1.661,0,0,1-1.66,1.66H160.7a1.661,1.661,0,0,1-1.661-1.66v-10.64a4.423,4.423,0,0,1,4.423-4.423h7.394a4.422,4.422,0,0,1,4.422,4.423Zm-4.422-16.238h-7.394a5.6,5.6,0,0,0-5.6,5.6v10.64A2.836,2.836,0,0,0,160.7,299.6h12.918a2.836,2.836,0,0,0,2.836-2.836v-10.64a5.6,5.6,0,0,0-5.6-5.6",
    transform: "translate(-120.404 -213.967)",
    fill: "#4048b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 0.705,
    height: 2.082,
    transform: "translate(46.398 85.635)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M178.32,351.044H165.4a1.659,1.659,0,0,1-1.372-.724l.088-.3a1.657,1.657,0,0,0,1.284.608h12.965a1.66,1.66,0,0,0,1.613-1.66v.419a1.66,1.66,0,0,1-1.66,1.66",
    transform: "translate(-125.11 -266.165)",
    fill: "#361e9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M177.376,302.2H164.489a1.676,1.676,0,0,1-1.676-1.676V289.946a4.464,4.464,0,0,1,4.464-4.464h7.311a4.464,4.464,0,0,1,4.464,4.464v10.582a1.676,1.676,0,0,1-1.676,1.676",
    transform: "translate(-124.182 -217.745)",
    fill: "#97d8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 0.705,
    height: 0.873,
    transform: "translate(46.398 85.635)",
    fill: "#1a254c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M169.02,379.905v0m0,0-.005-.021.005.021",
    transform: "translate(-128.912 -289.745)",
    fill: "#5792fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M182.157,380.233h-12.99a1.091,1.091,0,0,1-.147-.327v0l-.005-.021h13.3a1.089,1.089,0,0,1-.154.353",
    transform: "translate(-128.912 -289.745)",
    fill: "#361e9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M192.5,383.969h0a1.506,1.506,0,0,0,.038-.334v.014a1.471,1.471,0,0,1-.036.321m-3.986,0h0a1.488,1.488,0,0,1-.036-.321v-.014a1.493,1.493,0,0,0,.038.334",
    transform: "translate(-143.758 -292.458)",
    fill: "#5d83ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M192.5,383.969h-3.985a1.493,1.493,0,0,1-.038-.334v-.2h4.06v.2a1.506,1.506,0,0,1-.038.334",
    transform: "translate(-143.758 -292.458)",
    fill: "#1a254c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 0.705,
    height: 1.247,
    transform: "translate(46.398 92.666)",
    fill: "#707aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M199.107,405.779h0Zm0,0h0",
    transform: "translate(-151.862 -309.499)",
    fill: "#5792fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M193.92,414.054h-.353v-7.94a.335.335,0,0,1,.335-.335h.983a.334.334,0,0,1,.316.252h-.946a.335.335,0,0,0-.335.335Z",
    transform: "translate(-147.639 -309.499)",
    fill: "#262161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M190.612,441.321v-.006a.65.65,0,0,1,.65-.65h.006a.656.656,0,0,0-.656.656m2.921-.388h0a.655.655,0,0,0-.529-.268h.006a.647.647,0,0,1,.523.268",
    transform: "translate(-145.385 -336.108)",
    fill: "#9dc1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M190.94,441.37h-.328v-.049a.656.656,0,0,1,.656-.656H193a.655.655,0,0,1,.529.268.641.641,0,0,0-.22-.041h-1.748a.648.648,0,0,0-.624.479",
    transform: "translate(-145.385 -336.108)",
    fill: "#707aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M164.377,446.126v-.006a.675.675,0,0,1,0-.08h0a.67.67,0,0,0-.005.085",
    transform: "translate(-125.375 -340.207)",
    fill: "#69a1ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M164.4,444.208h0a.65.65,0,0,1,.645-.57h.006a.656.656,0,0,0-.651.571m15.43-.193h0a.656.656,0,0,0-.594-.377h.006a.649.649,0,0,1,.588.378",
    transform: "translate(-125.39 -338.375)",
    fill: "#5792fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M164.843,445.044h-.466v-.751a.67.67,0,0,1,.005-.085.656.656,0,0,1,.651-.571h14.185a.657.657,0,0,1,.594.377.666.666,0,0,0-.122-.012h-14.2a.65.65,0,0,0-.65.65Z",
    transform: "translate(-125.375 -338.375)",
    fill: "#262161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M232.3,369.69h0Zm0,0h0m0,0h0",
    transform: "translate(-177.176 -281.973)",
    fill: "#efcec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M158.167,372.059a1.217,1.217,0,0,1-.707-.527l.5-1.718a1.2,1.2,0,0,1,.533-.123h16.736a1.2,1.2,0,0,1,.937.47,1.2,1.2,0,0,0-.321-.049H159.118a1.209,1.209,0,0,0-1.209,1.209,1.2,1.2,0,0,0,.258.738",
    transform: "translate(-120.099 -281.973)",
    fill: "#6ccbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M178.6,352.823h-.016a1.677,1.677,0,0,0,1.524-.976h0a1.66,1.66,0,0,1-1.465.976H178.6Zm-12.9,0h-.016a1.657,1.657,0,0,1-1.284-.608l0-.007a1.673,1.673,0,0,0,1.3.616",
    transform: "translate(-125.392 -268.364)",
    fill: "#efcec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M178.6,354.007H165.683a1.657,1.657,0,0,1-1.284-.608,1.657,1.657,0,0,0,1.284.608H178.6Zm.007,0h0m.008,0h0m.008,0h0m.008,0h0m.008,0h0m.008,0h0",
    transform: "translate(-125.392 -269.547)",
    fill: "#232959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M162.813,294.064v-.042s0-.007,0-.011v0h0v-.013h0a4.408,4.408,0,0,1,1.311-3.113l-.019.042a4.449,4.449,0,0,0-1.292,3.141",
    transform: "translate(-124.182 -221.863)",
    fill: "#efcec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M162.813,304.028s0-.007,0-.011,0,.007,0,.011m0-.014h0m0-.014h0",
    transform: "translate(-124.182 -231.869)",
    fill: "#493196"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M177.376,306.459H164.489a1.673,1.673,0,0,1-1.3-.615l.509-1.764.061-.213v.495a1.124,1.124,0,0,0,1.124,1.124h13.991l.023,0a1.677,1.677,0,0,1-1.524.976m-13.614-6.728h-.949V294.2a4.449,4.449,0,0,1,1.292-3.141,3.863,3.863,0,0,0-.343,1.589v7.083",
    transform: "translate(-124.182 -222)",
    fill: "#6ccbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 0.705,
    height: 13.44,
    transform: "translate(109.643 91.822)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M441.185,372.108H424.462a1.209,1.209,0,0,1,0-2.418h16.723a1.209,1.209,0,0,1,0,2.418",
    transform: "translate(-322.827 -281.973)",
    fill: "#97d8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M457.6,385.124H456.52a1.489,1.489,0,0,1-1.488-1.489v-.2h4.06v.2a1.489,1.489,0,0,1-1.488,1.489",
    transform: "translate(-347.066 -292.458)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M436.628,380.724H447.8a1.091,1.091,0,0,0,1.061-.844h-13.3a1.091,1.091,0,0,0,1.061.844",
    transform: "translate(-332.219 -289.745)",
    fill: "#4048b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M461.765,414.762H460.12v-8.648a.335.335,0,0,1,.335-.335h.975a.335.335,0,0,1,.335.335Z",
    transform: "translate(-350.947 -309.499)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M460.213,441.37h-3.047v-.049a.656.656,0,0,1,.656-.656h1.736a.656.656,0,0,1,.656.656Z",
    transform: "translate(-348.694 -336.108)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M446.427,445.047h-15.5v-.755a.656.656,0,0,1,.656-.656h14.185a.656.656,0,0,1,.656.656Z",
    transform: "translate(-328.683 -338.375)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M441.828,296.767a1.661,1.661,0,0,1-1.661,1.66H427.25a1.661,1.661,0,0,1-1.66-1.66v-10.64a4.423,4.423,0,0,1,4.423-4.423h7.394a4.423,4.423,0,0,1,4.423,4.423Zm-4.423-16.238h-7.394a5.6,5.6,0,0,0-5.6,5.6v10.64a2.836,2.836,0,0,0,2.836,2.836h12.918A2.836,2.836,0,0,0,443,296.767v-10.64a5.6,5.6,0,0,0-5.6-5.6",
    transform: "translate(-323.713 -213.967)",
    fill: "#4048b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 0.705,
    height: 2.082,
    transform: "translate(109.643 85.635)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M443.945,351.044H431.027a1.66,1.66,0,0,1-1.66-1.66v-.419a1.661,1.661,0,0,0,1.66,1.66H444a1.659,1.659,0,0,0,1.3-.7l.083.29a1.66,1.66,0,0,1-1.437.827",
    transform: "translate(-327.49 -266.165)",
    fill: "#361e9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M443.93,302.2H431.043a1.676,1.676,0,0,1-1.676-1.676V289.946a4.464,4.464,0,0,1,4.464-4.464h7.311a4.464,4.464,0,0,1,4.464,4.464v10.582a1.676,1.676,0,0,1-1.676,1.676",
    transform: "translate(-327.49 -217.745)",
    fill: "#97d8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 0.705,
    height: 0.873,
    transform: "translate(109.643 85.635)",
    fill: "#1a254c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M448.71,380.233H435.72a1.1,1.1,0,0,1-.153-.353h13.3a1.09,1.09,0,0,1-.153.353",
    transform: "translate(-332.219 -289.745)",
    fill: "#361e9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M459.056,383.969h0a1.493,1.493,0,0,0,.038-.334v.014a1.488,1.488,0,0,1-.036.321m-3.987,0h0a1.471,1.471,0,0,1-.036-.321v-.014a1.506,1.506,0,0,0,.038.334",
    transform: "translate(-347.066 -292.458)",
    fill: "#5d83ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M459.054,383.969H455.07a1.506,1.506,0,0,1-.038-.334v-.2h4.06v.2a1.493,1.493,0,0,1-.038.334",
    transform: "translate(-347.066 -292.458)",
    fill: "#1a254c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 0.705,
    height: 1.247,
    transform: "translate(109.643 92.666)",
    fill: "#707aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M465.661,405.779h0Zm0,0h0",
    transform: "translate(-355.17 -309.499)",
    fill: "#5792fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M460.473,414.054h-.353v-7.94a.335.335,0,0,1,.335-.335h.983a.334.334,0,0,1,.316.252h-.946a.335.335,0,0,0-.335.335Z",
    transform: "translate(-350.947 -309.499)",
    fill: "#262161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M457.166,441.321v-.006a.65.65,0,0,1,.65-.65h.006a.656.656,0,0,0-.656.656",
    transform: "translate(-348.694 -336.108)",
    fill: "#9dc1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M467.774,440.933h0a.655.655,0,0,0-.529-.268h.006a.647.647,0,0,1,.523.268",
    transform: "translate(-356.381 -336.108)",
    fill: "#d5cbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M457.494,441.37h-.328v-.049a.656.656,0,0,1,.656-.656h1.736a.655.655,0,0,1,.529.268.642.642,0,0,0-.221-.041h-1.748a.648.648,0,0,0-.624.479",
    transform: "translate(-348.694 -336.108)",
    fill: "#707aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M430.93,444.293v-.006a.65.65,0,0,1,.65-.65h.006a.656.656,0,0,0-.656.656",
    transform: "translate(-328.683 -338.375)",
    fill: "#5792fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M494.074,444.015h0a.656.656,0,0,0-.594-.377h.006a.649.649,0,0,1,.588.378",
    transform: "translate(-376.391 -338.375)",
    fill: "#69a1ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M431.4,445.044h-.466v-.751a.656.656,0,0,1,.656-.656h14.185a.657.657,0,0,1,.594.377.67.67,0,0,0-.122-.012h-14.2a.65.65,0,0,0-.65.65Z",
    transform: "translate(-328.683 -338.375)",
    fill: "#262161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M423.253,370.912h0Zm0-.007h0M441.2,369.69h0m0,0h0m0,0h0",
    transform: "translate(-322.827 -281.973)",
    fill: "#efcec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M424.141,372.059a1.205,1.205,0,0,1-.888-1.147h0v-.006h0V370.9a1.209,1.209,0,0,1,1.209-1.209H441.2a1.185,1.185,0,0,1,.633.191l.068.234c-.028,0-.056,0-.085,0H425.092a1.209,1.209,0,0,0-1.209,1.209,1.2,1.2,0,0,0,.258.738",
    transform: "translate(-322.827 -281.973)",
    fill: "#6ccbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M443.945,306.323h-.015a1.674,1.674,0,0,0,1.366-.705l0,.006a1.656,1.656,0,0,1-1.3.7h-.055Zm-12.9,0h-.016a1.661,1.661,0,0,1-1.66-1.66v-.016a1.676,1.676,0,0,0,1.676,1.676m-1.676-12.259v-.056h0v-.013h0a4.408,4.408,0,0,1,1.311-3.113l-.019.042a4.45,4.45,0,0,0-1.292,3.141",
    transform: "translate(-327.49 -221.863)",
    fill: "#efcec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M429.367,304.028v0Zm0-.014h0m0-.014h0",
    transform: "translate(-327.49 -231.869)",
    fill: "#493196"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M443.945,350.624H431.027a1.661,1.661,0,0,1-1.66-1.66,1.661,1.661,0,0,0,1.66,1.66h12.918Zm.007,0h0m.008,0h0m.008,0h0m.008,0h0m.008,0h0m.008,0h0m.008,0h0",
    transform: "translate(-327.49 -266.165)",
    fill: "#232959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M443.93,306.459H431.043a1.676,1.676,0,0,1-1.676-1.676v-2.567h.949v2.145a1.124,1.124,0,0,0,1.124,1.124h13.78l.077.269a1.674,1.674,0,0,1-1.366.705m-13.614-6.728h-.949V294.2a4.45,4.45,0,0,1,1.292-3.141,3.863,3.863,0,0,0-.343,1.589v7.083",
    transform: "translate(-327.49 -221.999)",
    fill: "#6ccbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 0.705,
    height: 13.44,
    transform: "translate(78.068 91.822)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M308.107,372.108H291.385a1.209,1.209,0,0,1,0-2.418h16.722a1.209,1.209,0,1,1,0,2.418",
    transform: "translate(-221.326 -281.973)",
    fill: "#97d8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M324.526,385.124h-1.083a1.489,1.489,0,0,1-1.488-1.489v-.2h4.06v.2a1.489,1.489,0,0,1-1.489,1.489",
    transform: "translate(-245.564 -292.458)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M303.551,380.724h11.175a1.091,1.091,0,0,0,1.061-.844h-13.3a1.091,1.091,0,0,0,1.061.844",
    transform: "translate(-230.718 -289.745)",
    fill: "#4048b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M328.688,414.762h-1.645v-8.648a.335.335,0,0,1,.335-.335h.975a.335.335,0,0,1,.335.335Z",
    transform: "translate(-249.445 -309.499)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M327.136,441.37h-3.048v-.049a.656.656,0,0,1,.656-.656h1.736a.656.656,0,0,1,.656.656Z",
    transform: "translate(-247.191 -336.108)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M313.351,445.047h-15.5v-.755a.656.656,0,0,1,.656-.656H312.7a.656.656,0,0,1,.656.656Z",
    transform: "translate(-227.182 -338.375)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M308.751,296.767a1.661,1.661,0,0,1-1.66,1.66H294.173a1.661,1.661,0,0,1-1.66-1.66v-10.64a4.423,4.423,0,0,1,4.423-4.423h7.394a4.423,4.423,0,0,1,4.423,4.423Zm-4.423-16.238h-7.394a5.6,5.6,0,0,0-5.6,5.6v10.64a2.836,2.836,0,0,0,2.836,2.836h12.918a2.836,2.836,0,0,0,2.836-2.836v-10.64a5.6,5.6,0,0,0-5.6-5.6",
    transform: "translate(-222.211 -213.967)",
    fill: "#4048b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 0.705,
    height: 2.082,
    transform: "translate(78.068 85.635)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M310.869,351.044H297.95a1.66,1.66,0,0,1-1.66-1.66v-.419a1.661,1.661,0,0,0,1.66,1.66h12.973a1.661,1.661,0,0,0,1.605-1.659v.419a1.66,1.66,0,0,1-1.66,1.66",
    transform: "translate(-225.989 -266.165)",
    fill: "#361e9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M310.853,302.2H297.966a1.676,1.676,0,0,1-1.676-1.676V289.946a4.464,4.464,0,0,1,4.464-4.464h7.311a4.464,4.464,0,0,1,4.464,4.464v10.582a1.676,1.676,0,0,1-1.676,1.676",
    transform: "translate(-225.989 -217.745)",
    fill: "#97d8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 0.705,
    height: 0.873,
    transform: "translate(78.068 85.635)",
    fill: "#1a254c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M358.484,379.922v0m0,0c0-.013.007-.026.01-.039,0,.013-.006.026-.01.039",
    transform: "translate(-273.426 -289.745)",
    fill: "#5792fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M315.633,380.233h-12.99a1.09,1.09,0,0,1-.154-.353h13.3c0,.013-.006.026-.01.039h0v0a1.1,1.1,0,0,1-.143.31",
    transform: "translate(-230.718 -289.745)",
    fill: "#361e9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M325.979,383.969h0a1.491,1.491,0,0,0,.038-.334v.014a1.488,1.488,0,0,1-.036.321m-3.987,0h0a1.471,1.471,0,0,1-.036-.321v-.014a1.491,1.491,0,0,0,.038.334",
    transform: "translate(-245.564 -292.458)",
    fill: "#5d83ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M325.977,383.969h-3.985a1.491,1.491,0,0,1-.038-.334v-.2h4.06v.2a1.491,1.491,0,0,1-.038.334",
    transform: "translate(-245.564 -292.458)",
    fill: "#1a254c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 0.705,
    height: 1.247,
    transform: "translate(78.068 92.666)",
    fill: "#707aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M332.584,405.779h0Zm0,0h0",
    transform: "translate(-253.668 -309.499)",
    fill: "#5792fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M327.4,414.054h-.353v-7.94a.335.335,0,0,1,.335-.335h.983a.334.334,0,0,1,.316.252h-.946a.335.335,0,0,0-.335.335Z",
    transform: "translate(-249.445 -309.499)",
    fill: "#262161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M324.088,441.321v-.006a.65.65,0,0,1,.65-.65h.006a.656.656,0,0,0-.656.656m2.921-.388h0a.655.655,0,0,0-.528-.267h.006a.647.647,0,0,1,.524.268",
    transform: "translate(-247.191 -336.108)",
    fill: "#9dc1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M324.416,441.37h-.328v-.049a.656.656,0,0,1,.656-.656h1.736a.655.655,0,0,1,.528.267.645.645,0,0,0-.22-.041H325.04a.648.648,0,0,0-.624.479",
    transform: "translate(-247.191 -336.108)",
    fill: "#707aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M297.854,444.293v-.006a.65.65,0,0,1,.65-.65h.006a.656.656,0,0,0-.656.656m15.435-.278h0a.656.656,0,0,0-.594-.377h.006a.649.649,0,0,1,.588.378",
    transform: "translate(-227.182 -338.375)",
    fill: "#5792fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M298.32,445.044h-.466v-.751a.656.656,0,0,1,.656-.656H312.7a.656.656,0,0,1,.594.377.665.665,0,0,0-.122-.012h-14.2a.65.65,0,0,0-.65.65Z",
    transform: "translate(-227.182 -338.375)",
    fill: "#262161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M290.176,370.912h0Zm0-.007h0m17.945-1.216h0m0,0h0m0,0h0",
    transform: "translate(-221.326 -281.973)",
    fill: "#efcec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M291.064,372.059a1.206,1.206,0,0,1-.888-1.147h0v-.006h0V370.9a1.209,1.209,0,0,1,1.209-1.209h16.736a1.2,1.2,0,0,1,.937.47,1.2,1.2,0,0,0-.321-.049H292.014a1.209,1.209,0,0,0-1.209,1.209,1.2,1.2,0,0,0,.258.738",
    transform: "translate(-221.326 -281.973)",
    fill: "#6ccbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M357.683,352.823h-.016a1.676,1.676,0,0,0,1.523-.976h0a1.66,1.66,0,0,1-1.457.975h-.055Z",
    transform: "translate(-272.803 -268.364)",
    fill: "#efcec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M297.966,350.573h-.016a1.661,1.661,0,0,1-1.66-1.66V348.9a1.676,1.676,0,0,0,1.676,1.676",
    transform: "translate(-225.989 -266.114)",
    fill: "#efcec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M310.869,350.624H297.95a1.661,1.661,0,0,1-1.66-1.66,1.661,1.661,0,0,0,1.66,1.66h12.918Zm.007,0h0m.008,0h0m.008,0h0m.008,0h0m.008,0h0m.008,0h0m.008,0h0",
    transform: "translate(-225.989 -266.165)",
    fill: "#232959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M310.853,342.322H297.966a1.676,1.676,0,0,1-1.676-1.676v-2.567h.949v2.145a1.124,1.124,0,0,0,1.124,1.124h13.991l.023,0a1.677,1.677,0,0,1-1.523.976",
    transform: "translate(-225.989 -257.863)",
    fill: "#6ccbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M296.29,294.064v-.056h0v-.013h0a4.408,4.408,0,0,1,1.311-3.113l-.019.042a4.451,4.451,0,0,0-1.292,3.141",
    transform: "translate(-225.989 -221.863)",
    fill: "#efcec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M296.29,304.028v0Zm0-.014h0m0-.014h0",
    transform: "translate(-225.989 -231.869)",
    fill: "#493196"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M297.239,299.731h-.949V294.2a4.451,4.451,0,0,1,1.292-3.141,3.862,3.862,0,0,0-.343,1.589Z",
    transform: "translate(-225.989 -222)",
    fill: "#6ccbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M185.334,330.091H57.831a1.242,1.242,0,0,1,0-2.485h127.5a1.242,1.242,0,0,1,0,2.485",
    transform: "translate(-43.162 -249.874)",
    fill: "#4038b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M73.569,365.111h-.611a.6.6,0,0,1-.563-.8l9.353-26.233h1.881l-9.5,26.635a.6.6,0,0,1-.563.4",
    transform: "translate(-55.191 -257.863)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M133.238,362.525h-.615a.608.608,0,0,1-.584-.777l6.828-23.669h1.88l-6.925,24.007a.608.608,0,0,1-.584.439",
    transform: "translate(-100.692 -257.863)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M551.229,365.111h.611a.6.6,0,0,0,.563-.8l-9.353-26.233h-1.88l9.5,26.635a.6.6,0,0,0,.563.4",
    transform: "translate(-412.766 -257.863)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M499.712,362.525h.615a.608.608,0,0,0,.584-.777l-6.828-23.669H492.2l6.925,24.007a.608.608,0,0,0,.584.439",
    transform: "translate(-375.417 -257.863)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M111.005,339.943h-1.88l.664-1.864h1.881Z",
    transform: "translate(-83.233 -257.862)",
    fill: "#707aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M166.811,339.729h0l.476-1.65Z",
    transform: "translate(-127.232 -257.862)",
    fill: "#9eadc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M166.552,345.248h0l.061-.213Z",
    transform: "translate(-127.034 -263.168)",
    fill: "#8fa3c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M160.507,339.943h-1.88l.538-1.864h1.88l-.476,1.65Z",
    transform: "translate(-120.989 -257.862)",
    fill: "#707aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M549.76,339.943h0l-.665-1.864Z",
    transform: "translate(-418.81 -257.862)",
    fill: "#9dc1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M543.715,339.943h-1.873l-.672-1.864h1.88Z",
    transform: "translate(-412.766 -257.862)",
    fill: "#707aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M492.74,339.943h0l-.537-1.864Z",
    transform: "translate(-375.417 -257.862)",
    fill: "#9eadc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M494.621,339.943h-1.88l-.537-1.864h1.88Z",
    transform: "translate(-375.417 -257.862)",
    fill: "#707aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M186.576,332.832v0Zm-129.987,0v0",
    transform: "translate(-43.162 -253.857)",
    fill: "#8e94de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M185.334,332.735H57.831a1.242,1.242,0,0,1-1.242-1.242v0a1.233,1.233,0,0,1,.078-.416,1.239,1.239,0,0,0,1.165.823h127.5a1.239,1.239,0,0,0,1.165-.823,1.234,1.234,0,0,1,.078.416v0a1.242,1.242,0,0,1-1.242,1.242",
    transform: "translate(-43.162 -252.519)",
    fill: "#312470"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M160.714,451.433H9.191a.627.627,0,0,1-.627-.627V450.2a.627.627,0,0,1,.627-.627H160.714a.627.627,0,0,1,.627.627v.611a.627.627,0,0,1-.627.627",
    transform: "translate(-6.532 -342.898)",
    fill: "#5f7eff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 0.705,
    height: 13.44,
    transform: "translate(12.625 91.834)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M6.984,364.606H5.212a1.605,1.605,0,0,1-1.6-1.6v-2.04h.705V363a.9.9,0,0,0,.9.9H6.984Z",
    transform: "translate(-2.753 -275.317)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M32.29,372.156H15.567a1.209,1.209,0,1,1,0-2.418H32.29a1.209,1.209,0,1,1,0,2.418",
    transform: "translate(-10.951 -282.01)",
    fill: "#97d8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M48.709,385.171H47.626a1.489,1.489,0,0,1-1.489-1.489v-.2H50.2v.2a1.489,1.489,0,0,1-1.488,1.489",
    transform: "translate(-35.19 -292.493)",
    fill: "#3f29a1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(0.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M27.734,380.772H38.909a1.09,1.09,0,0,0,1.061-.844h-13.3a1.091,1.091,0,0,0,1.061.844",
    transform: "translate(-20.373 -289.782)",
    fill: "#4048b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M0,301.269V284.546a1.209,1.209,0,0,1,2.418,0v16.723a1.209,1.209,0,1,1-2.418,0",
    transform: "translate(-0.028 -216.109)",
    fill: "#4048b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M10.19,288.432v16.723s2.552-1.142,2.552-8.361-2.552-8.361-2.552-8.361",
    transform: "translate(-7.772 -219.995)",
    fill: "#97d8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M52.87,414.81H51.225v-8.648a.335.335,0,0,1,.335-.335h.975a.335.335,0,0,1,.335.335Z",
    transform: "translate(-39.071 -309.536)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M51.318,441.418H48.271v-.049a.656.656,0,0,1,.656-.656h1.736a.656.656,0,0,1,.656.656Z",
    transform: "translate(-36.818 -336.144)",
    fill: "#839aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M37.533,445.1h-15.5v-.755a.656.656,0,0,1,.656-.656H36.877a.656.656,0,0,1,.656.656Z",
    transform: "translate(-16.807 -338.411)",
    fill: "#3f29a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M69.2,445.1H67.8a12.733,12.733,0,0,0-1.521-1.41h1.181Z",
    transform: "translate(-50.551 -338.411)",
    fill: "#262161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M10.19,305.638V290.31a4,4,0,0,0,.32.6c.075,3.568.42,7.138.768,10.693l.006.057c0,.011,0,.021,0,.031h0a8.93,8.93,0,0,0-.159,2.194,16.662,16.662,0,0,1-.937,1.747",
    transform: "translate(-7.772 -221.428)",
    fill: "#6ecfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M34.649,372.156H33.443a.5.5,0,0,0-.119-.186.956.956,0,0,0-.479-.209,32.537,32.537,0,0,0-7.2-.808h-.178c-.314,0-.629.008-.944.008a8.478,8.478,0,0,1-1.956-.178,3.694,3.694,0,0,1-1.884-1.044H22.69a7.933,7.933,0,0,0,2.017.459h0l.016,0h.023c.47.047.941.062,1.413.062h0c.581,0,1.163-.024,1.745-.043h.018l.234-.007h.053l.26-.007q.624-.015,1.247-.015a53.347,53.347,0,0,1,5.367.272c-.089.293-.171.589-.247.888q-.042.166-.082.332l0,.016q-.055.229-.107.458",
    transform: "translate(-15.772 -282.01)",
    fill: "#6ecfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M75.307,436.651h0l.07-.012c-.053.009-.107.019-.158.024h0c.028,0,.058-.007.087-.012",
    transform: "translate(-57.352 -333.037)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M75.955,427.662l-.049-.014Z",
    transform: "translate(-57.896 -326.179)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M77.41,428.058c.122.028.244.05.365.067-.083-.011-.167-.029-.251-.046-.038-.008-.076-.012-.114-.021",
    transform: "translate(-59.043 -326.492)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M73.244,436.552a1.948,1.948,0,0,0,.262.042,1.948,1.948,0,0,1-.262-.042",
    transform: "translate(-55.865 -332.971)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M77.337,435.619v0Z",
    transform: "translate(-58.987 -332.259)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M70.4,435.752l.06.021c.124.03.247.068.371.1-.124-.035-.247-.073-.371-.1a.339.339,0,0,1-.071-.027Z",
    transform: "translate(-53.688 -332.356)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M70.116,435.582l-.041-.026.011.009,0,0Z",
    transform: "translate(-53.448 -332.211)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M79.425,378.541q.068-.309.141-.614-.073.306-.141.614",
    transform: "translate(-60.58 -288.256)",
    fill: "#3e29a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M80.366,372.532c.107-.42.225-.835.36-1.243-.135.407-.253.822-.36,1.243",
    transform: "translate(-61.297 -283.193)",
    fill: "#3e29a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M79,427.737h0a.286.286,0,0,0,.3-.186h0a.286.286,0,0,1-.3.186",
    transform: "translate(-60.258 -326.105)",
    fill: "#3e29a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M75.9,427.648h0l.049.014h0Z",
    transform: "translate(-57.895 -326.179)",
    fill: "#3e29a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M77.409,428.058h0c.038.009.076.013.114.021-.038-.008-.076-.012-.114-.021",
    transform: "translate(-59.042 -326.492)",
    fill: "#3e29a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M69.136,434.786l.02.014Z",
    transform: "translate(-52.732 -331.624)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M78.769,436.58l.024.012Z",
    transform: "translate(-60.079 -332.992)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M77.384,436.415h0Z",
    transform: "translate(-59.023 -332.865)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M78.367,436.446l.016,0Z",
    transform: "translate(-59.773 -332.89)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M77.86,436.4h0Z",
    transform: "translate(-59.386 -332.852)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M69.335,434.927l.012.009Z",
    transform: "translate(-52.884 -331.731)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M69.238,444.005c.9.683,1.785,1.384,2.665,2.092.157.126.315.271.477.417-.162-.146-.32-.291-.477-.417-.88-.708-1.765-1.409-2.665-2.092",
    transform: "translate(-52.81 -338.655)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M65.925,441.416l-.113-.089.113.089",
    transform: "translate(-50.197 -336.613)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M66.6,441.947l-.311-.244.311.244",
    transform: "translate(-50.559 -336.899)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M66.37,435.853c.062-.081.118-.148.17-.2-.051.056-.108.124-.17.2",
    transform: "translate(-50.622 -332.281)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M68.637,434.639a.214.214,0,0,1,.1.025.213.213,0,0,0-.1-.025",
    transform: "translate(-52.351 -331.512)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M65.671,441.229l-.007,0Z",
    transform: "translate(-50.084 -336.536)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M65.6,441.193l-.014-.007Z",
    transform: "translate(-50.024 -336.505)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M65.709,441.245l.024.019Z",
    transform: "translate(-50.118 -336.55)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M79.99,439.765c-.014-.1-.025-.2-.03-.293.005.1.016.2.03.293",
    transform: "translate(-60.988 -335.197)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M64.9,438.677c-.151.4.042.552.12.595-.078-.044-.271-.2-.12-.595",
    transform: "translate(-49.455 -334.591)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M86.092,457.34a.146.146,0,0,1-.07-.025.146.146,0,0,0,.07.025",
    transform: "translate(-65.611 -348.807)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M80.473,442.5c.013.046.027.092.042.137-.015-.045-.029-.091-.042-.137",
    transform: "translate(-61.379 -337.504)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M67.718,434.765a.456.456,0,0,1,.156-.088.459.459,0,0,0-.156.088",
    transform: "translate(-51.65 -331.541)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M80.883,443.738c.012.032.026.064.039.1-.013-.032-.027-.063-.039-.1",
    transform: "translate(-61.692 -338.452)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M68.423,434.645l.038-.006Z",
    transform: "translate(-52.188 -331.512)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M80.169,441.168c.011.06.022.119.036.178-.014-.059-.025-.118-.036-.178",
    transform: "translate(-61.147 -336.491)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M83.726,448.322c.055.061.112.12.172.176-.06-.056-.116-.116-.172-.176",
    transform: "translate(-63.86 -341.948)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M67.1,435.417c.023-.025.045-.046.066-.067-.021.02-.043.042-.066.067",
    transform: "translate(-51.178 -332.054)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M67.441,435.118l.059-.052Z",
    transform: "translate(-51.439 -331.837)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M81.392,444.914l0,0Z",
    transform: "translate(-62.08 -339.349)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M70.126,435.6l0,0Z",
    transform: "translate(-53.484 -332.239)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M87.247,457.166l-.056.024Z",
    transform: "translate(-66.503 -348.694)",
    fill: "#232a3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M87.065,457.269l-.039.014Z",
    transform: "translate(-66.377 -348.772)",
    fill: "#232a3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M87.47,457.076l-.041.021Z",
    transform: "translate(-66.685 -348.625)",
    fill: "#232a3e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(0.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M87.625,457.019h0l-.022.014Z",
    transform: "translate(-66.845 -348.581)",
    fill: "#232a3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M86.4,457.413a.326.326,0,0,1-.079,0,.326.326,0,0,0,.079,0",
    transform: "translate(-65.866 -348.882)",
    fill: "#232a3e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M70.738,440.337a1.236,1.236,0,0,0-.38-.807,6.518,6.518,0,0,0-.535-.474,2.106,2.106,0,0,1-.477-.213,3.645,3.645,0,0,1-1.3-1.328,3.511,3.511,0,0,1-.324-.793,3.762,3.762,0,0,1-.129-.732c-.029,0-.059.009-.087.012h-.027a1.23,1.23,0,0,1-.2,0,1.945,1.945,0,0,1-.261-.042c-.079-.018-.157-.039-.235-.061-.124-.036-.247-.073-.371-.1l-.06-.021c-.05.039-.1.079-.148.119a1.17,1.17,0,0,1-.285.184.683.683,0,0,1-.591-.047l.033-.047a1.982,1.982,0,0,0-.28.48l5.366,4.352a.56.56,0,0,0,.294-.476",
    transform: "translate(-49.637 -332.376)",
    fill: "#232a3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M86.68,457.388l-.031.006Z",
    transform: "translate(-66.09 -348.863)",
    fill: "#232a3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M86.837,457.327l-.059.014Z",
    transform: "translate(-66.188 -348.816)",
    fill: "#232a3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M86.318,457.421Z",
    transform: "translate(-65.837 -348.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M65.078,438.677Z",
    transform: "translate(-49.637 -334.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M65.584,441.184h0Z",
    transform: "translate(-50.022 -336.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M65.649,441.219l0,0Z",
    transform: "translate(-50.069 -336.529)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(0.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M65.692,441.238l0,0Z",
    transform: "translate(-50.134 -336.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M70.266,443.03,64.9,438.677c-.151.4.042.551.12.595h0l.014.007,0,0,.007,0,0,0,.024.019.113.089.311.244c.139.109.283.221.389.3.9.683,1.785,1.384,2.665,2.092.156.126.315.271.477.417a4.737,4.737,0,0,0,.841.649.147.147,0,0,0,.07.025h0a.564.564,0,0,0,.328-.094",
    transform: "translate(-49.485 -334.591)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M67.376,435.3l.016-.015Z",
    transform: "translate(-51.39 -332.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M67.086,435.637l0,0Z",
    transform: "translate(-51.168 -332.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M68.585,434.639h0Z",
    transform: "translate(-52.312 -331.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M68.376,434.667l.011,0Z",
    transform: "translate(-52.152 -331.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M67.691,435.051l.006,0Z",
    transform: "translate(-51.63 -331.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M69.221,434.843l.027.02Z",
    transform: "translate(-52.797 -331.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M69.054,434.743l.019.01Z",
    transform: "translate(-52.669 -331.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M66.368,436.51h0Z",
    transform: "translate(-50.62 -332.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M69.5,435.067c-.04-.034-.077-.07-.114-.1.037.031.075.067.114.1",
    transform: "translate(-52.921 -331.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M66.744,435.079a.921.921,0,0,0,.453-.261c-.04-.034-.077-.07-.114-.1l-.012-.009-.027-.02-.02-.013-.019-.01a.213.213,0,0,0-.1-.025h-.012l-.038.006-.011,0a.457.457,0,0,0-.156.088l-.006,0-.059.052-.015.015c-.021.02-.043.042-.066.067l0,0c-.051.056-.107.124-.17.2h0a.909.909,0,0,0,.378-.005",
    transform: "translate(-50.619 -331.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M84.6,449.194h0c-.05-.042-.1-.086-.149-.131.048.045.1.088.149.131",
    transform: "translate(-64.412 -342.513)",
    fill: "#1a254c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M85.076,449.613",
    transform: "translate(-64.89 -342.933)",
    fill: "#19151d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M83.357,447.9c-.04-.042-.078-.086-.115-.131.037.045.076.088.115.131",
    transform: "translate(-63.491 -341.526)",
    fill: "#1a254c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M75.675,436.625c.04-.006.081-.012.122-.02l-.052.008Z",
    transform: "translate(-57.719 -333.011)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M75.69,436.625l.067-.012.052-.008-.119.02",
    transform: "translate(-57.731 -333.011)",
    fill: "#7068c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M77.887,441.671a3.638,3.638,0,0,1-1.148-1.224,3.424,3.424,0,0,1-.274-.634l-.243-.04a3.5,3.5,0,0,0,.324.793,3.642,3.642,0,0,0,1.3,1.328,2.092,2.092,0,0,0,.477.214c-.05-.042-.1-.086-.149-.13s-.117-.115-.172-.176c-.04-.042-.078-.086-.115-.131",
    transform: "translate(-58.136 -335.428)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M78.321,442.109a1.868,1.868,0,0,1-.215-.078h0a2.312,2.312,0,0,1-.262-.135,3.642,3.642,0,0,1-1.3-1.328,3.514,3.514,0,0,1-.324-.793l.243.04a3.424,3.424,0,0,0,.275.634,3.635,3.635,0,0,0,1.148,1.224c.037.045.075.089.115.131.055.061.112.12.172.176s.1.088.149.13",
    transform: "translate(-58.135 -335.428)",
    fill: "#271c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M75.88,436.551l-.082.013c-.041.008-.082.014-.122.02a3.749,3.749,0,0,0,.129.732l.243.04a3.792,3.792,0,0,1-.168-.8",
    transform: "translate(-57.72 -332.97)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M76.049,437.355l-.243-.04a3.749,3.749,0,0,1-.129-.732c.04-.006.081-.012.122-.02l.082-.013a3.792,3.792,0,0,0,.168.8",
    transform: "translate(-57.72 -332.97)",
    fill: "#271c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M77.26,436.421l.029,0-.029,0Z",
    transform: "translate(-58.929 -332.868)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M81.048,444.14c.026.062.052.123.082.184-.03-.06-.056-.122-.082-.184",
    transform: "translate(-61.818 -338.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M80.649,443.073c.017.053.036.106.056.158-.02-.052-.038-.1-.056-.158",
    transform: "translate(-61.513 -337.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M80.32,441.918c.011.046.023.092.036.137-.013-.045-.025-.091-.036-.137",
    transform: "translate(-61.262 -337.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M80.106,440.817c-.007-.036-.014-.073-.02-.109.005.037.013.073.02.109",
    transform: "translate(-61.084 -336.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M77.926,436.4a.629.629,0,0,1,.1.012.629.629,0,0,0-.1-.012",
    transform: "translate(-59.436 -332.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M78.434,436.464a.46.46,0,0,1,.08.027.46.46,0,0,0-.08-.027",
    transform: "translate(-59.824 -332.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M81.839,445.605a3.408,3.408,0,0,1-.437-.673,3.38,3.38,0,0,0,.437.673",
    transform: "translate(-62.088 -339.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M79.05,436.816a.418.418,0,0,0-.093-.128.385.385,0,0,0-.085-.059.38.38,0,0,1,.085.059.418.418,0,0,1,.093.128",
    transform: "translate(-60.158 -333.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M79.624,437.417a.756.756,0,0,1,.062.235.756.756,0,0,0-.062-.235",
    transform: "translate(-60.731 -333.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M77.425,436.4a1,1,0,0,1,.1,0,1,1,0,0,0-.1,0",
    transform: "translate(-59.054 -332.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M79.9,438.659h0c0-.082-.007-.168-.017-.251.01.083.013.169.017.251Z",
    transform: "translate(-60.932 -334.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M77.259,436.434h0Z",
    transform: "translate(-58.928 -332.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M77.245,437.243l-.034-.006a3.424,3.424,0,0,0,.275.634,3.64,3.64,0,0,0,1.148,1.224,3.391,3.391,0,0,1-.437-.673l0,0c-.029-.06-.056-.122-.082-.184-.013-.032-.027-.063-.039-.1-.02-.052-.038-.1-.056-.158s-.029-.091-.042-.137-.025-.091-.036-.137-.025-.118-.036-.178c-.006-.036-.014-.073-.019-.109-.014-.1-.025-.2-.03-.293h0c0-.082-.007-.168-.017-.251a.763.763,0,0,0-.063-.235.418.418,0,0,0-.093-.128.379.379,0,0,0-.085-.059l-.024-.012a.446.446,0,0,0-.08-.028l-.016,0a.629.629,0,0,0-.1-.012h-.016a1,1,0,0,0-.1,0h-.01l-.029,0a2.674,2.674,0,0,0,.031.838",
    transform: "translate(-58.883 -332.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M76.537,436.462a3.793,3.793,0,0,0,.168.8l.034.006a2.674,2.674,0,0,1-.031-.838h0c-.056.007-.114.018-.172.028",
    transform: "translate(-58.377 -332.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M83.242,447.769",
    transform: "translate(-63.491 -341.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M83.242,447.769",
    transform: "translate(-63.491 -341.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M66.258,436.547l.026-.033Z",
    transform: "translate(-50.537 -332.942)",
    fill: "#5692fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M69.911,435.428l-.044-.035.044.035Z",
    transform: "translate(-53.289 -332.087)",
    fill: "#5692fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M70.069,435.552l-.011-.009-.005,0h0Z",
    transform: "translate(-53.431 -332.198)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M70.069,435.554l-.016-.012.005,0Zm-.016-.012h0m0,0h0",
    transform: "translate(-53.431 -332.2)",
    fill: "#7068c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M70.383,435.745l-.011-.006-.006,0Z",
    transform: "translate(-53.67 -332.349)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M70.383,435.745l-.017-.008.006,0Z",
    transform: "translate(-53.67 -332.349)",
    fill: "#7068c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M70.18,435.63l-.016-.01-.026-.014Z",
    transform: "translate(-53.496 -332.248)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M70.18,435.63l-.042-.025.026.014Z",
    transform: "translate(-53.496 -332.248)",
    fill: "#7068c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M66.71,435.785A1.17,1.17,0,0,0,67,435.6l.057-.173-.044-.035a.921.921,0,0,1-.453.261.909.909,0,0,1-.378.005l-.026.033-.033.047a.684.684,0,0,0,.591.047",
    transform: "translate(-50.431 -332.087)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M66.469,435.832a.711.711,0,0,1-.35-.094l.033-.047.026-.033a.96.96,0,0,0,.181.017.85.85,0,0,0,.2-.023.921.921,0,0,0,.453-.261l.044.035L67,435.6a1.17,1.17,0,0,1-.285.184l-.008,0-.013.005a.645.645,0,0,1-.219.038Z",
    transform: "translate(-50.431 -332.087)",
    fill: "#271c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M69.944,435.588l-.012-.007-.042-.025,0,0-.016-.012-.057.173c.049-.04.1-.08.148-.119Z",
    transform: "translate(-53.248 -332.2)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M69.814,435.715l.057-.173.016.012,0,0,.042.025.012.007.017.008c-.047.036-.093.074-.139.111l-.009.007m.119-.134.012.007-.012-.007",
    transform: "translate(-53.249 -332.2)",
    fill: "#271c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M77.339,435.092q.009-.079.021-.164-.012.085-.021.164",
    transform: "translate(-58.989 -331.732)",
    fill: "#6c83ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M74.467,436.737h0c-.038,0-.075,0-.113-.005h0c.037,0,.073,0,.11,0h0l.079,0-.08,0Z",
    transform: "translate(-56.707 -333.107)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M74.467,436.737h0Zm0,0,.08,0-.08,0m-.116-.005h0",
    transform: "translate(-56.707 -333.107)",
    fill: "#1b2235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M75.972,436.564l.134-.023h0l-.082.014Z",
    transform: "translate(-57.946 -332.962)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M76.19,436.559l.082-.014h0l-.082.013",
    transform: "translate(-58.112 -332.965)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M77.26,436.429h0Z",
    transform: "translate(-58.929 -332.876)",
    fill: "#6c83ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M77.261,436.433Z",
    transform: "translate(-58.929 -332.88)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M76.536,436.5h0l.072-.013h0l-.072.012",
    transform: "translate(-58.376 -332.922)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M76.838,436.443h0l.1-.014h0l-.1.014m.1-.014h0",
    transform: "translate(-58.607 -332.876)",
    fill: "#6c83ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M77.259,436.434h0Z",
    transform: "translate(-58.928 -332.881)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M76.536,436.507h0l.072-.012h0l-.071.013",
    transform: "translate(-58.376 -332.926)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M76.837,436.449h0l.1-.014c-.033,0-.066.009-.1.015",
    transform: "translate(-58.606 -332.881)",
    fill: "#6c83ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M76.537,436.462h0l.071-.013c.034-.006.067-.011.1-.015-.056.007-.114.018-.172.028",
    transform: "translate(-58.377 -332.881)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M70.058,435.543l-.005,0h0Z",
    transform: "translate(-53.432 -332.198)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M70.282,435.685l-.006,0-.012-.007-.016-.01Z",
    transform: "translate(-53.581 -332.295)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M70.327,435.716l-.012-.007Z",
    transform: "translate(-53.631 -332.328)",
    fill: "#1c1e23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M78.675,428.589c.024-.082.05-.166.078-.252-.028.087-.054.17-.078.252",
    transform: "translate(-60.008 -326.705)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M79,428.337Z",
    transform: "translate(-60.259 -326.705)",
    fill: "#312b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M72.164,426.916h0c-.121-.017-.243-.039-.365-.067l-.014,0-.01,0c-.1-.022-.19-.05-.284-.078l-.049-.014q-.189-.059-.371-.134l-.031-.011c-.066-.028-.128-.06-.192-.091-.03-.014-.061-.028-.09-.042l-.705,2.151.005,0,.041.026.034.019a.342.342,0,0,0,.071.027c.124.03.247.068.371.1.078.023.157.043.235.061a1.935,1.935,0,0,0,.261.042,1.262,1.262,0,0,0,.2,0H71.3c.051,0,.1-.015.158-.024l.134-.023c.058-.01.116-.02.172-.027,0-.06.011-.123.018-.19v0c.008-.067.017-.138.028-.212a9.045,9.045,0,0,1,.284-1.247c.026-.087.053-.176.083-.269Z",
    transform: "translate(-53.431 -325.283)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M76.4,427.784c-.1-.022-.19-.05-.284-.078h0l.071.021c.07.021.14.04.211.056",
    transform: "translate(-58.054 -326.224)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M74.693,427.211c-.119-.038-.237-.081-.352-.128.115.047.233.09.352.128",
    transform: "translate(-56.702 -325.748)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M74.694,427.211c-.12-.038-.238-.081-.353-.128q.173.071.352.128h0",
    transform: "translate(-56.702 -325.748)",
    fill: "#9aa4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M78.948,428.338Z",
    transform: "translate(-60.216 -326.706)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M80.02,376.858q.04-.167.082-.332-.042.166-.082.332",
    transform: "translate(-61.034 -287.187)",
    fill: "#6f7d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M73.026,426.473h0Z",
    transform: "translate(-55.699 -325.283)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M77.89,428.146c.084.017.168.034.251.046h0c-.083-.011-.167-.029-.251-.046",
    transform: "translate(-59.409 -326.559)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M78.935,428.337h0",
    transform: "translate(-60.203 -326.704)",
    fill: "#7068c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M75.618,362.373l-.869-.029a.8.8,0,0,1,.152.893,11.924,11.924,0,0,0-.48,1.23c-.135.407-.253.822-.36,1.243q-.042.166-.082.332-.073.306-.141.614c-.087.394-.168.79-.249,1.185-.108.527-.215,1.052-.334,1.571-.02.086-.036.169-.054.253-.059.278-.113.55-.156.811-.036.213-.065.42-.093.624-.006.047-.013.095-.019.141-.024.191-.047.379-.066.564-.006.054-.011.107-.016.16q-.02.2-.037.39a32.287,32.287,0,0,1-.422,3.662l-.017.082c-.019.093-.039.186-.06.281-.013.06-.028.121-.042.182s-.033.14-.051.211c-.035.137-.071.275-.111.416l0,.006a.287.287,0,0,0,.143.332c.021.011.045.02.066.031h0a4.55,4.55,0,0,0,.683.279l.052.014c.1.031.2.06.3.083.038.009.076.013.114.021.084.017.168.035.251.046h.013a.286.286,0,0,0,.3-.186c.044-.124.088-.244.132-.366a71.86,71.86,0,0,1,4.666-9.973,32.372,32.372,0,0,0,1.63-4.185,2.727,2.727,0,0,0,.134-.756Z",
    transform: "translate(-54.992 -276.37)",
    fill: "#232a3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M73.026,426.473h0a4.553,4.553,0,0,0,.683.279l.052.014c.1.031.2.059.3.083.038.009.076.013.114.021.084.017.168.035.251.046h.013Z",
    transform: "translate(-55.699 -325.283)",
    fill: "#3e29a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M78.948,428.339Z",
    transform: "translate(-60.216 -326.706)",
    fill: "#9aa4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M78.948,428.339Z",
    transform: "translate(-60.216 -326.706)",
    fill: "#7068c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M76.658,427.859l-.013,0-.009,0c-.07-.016-.141-.036-.21-.056l.04.012c.064.018.129.035.193.05",
    transform: "translate(-58.292 -326.294)",
    fill: "#7183b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M76.786,427.9h0c-.065-.015-.129-.032-.193-.05.055.015.11.03.165.043l.028.007",
    transform: "translate(-58.42 -326.331)",
    fill: "#000e26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M77.321,428.039l-.01,0Z",
    transform: "translate(-58.967 -326.475)",
    fill: "#5653ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M77.321,428.039l-.01,0Z",
    transform: "translate(-58.967 -326.475)",
    fill: "#393e48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M76.2,427.73l-.071-.021.071.021",
    transform: "translate(-58.062 -326.226)",
    fill: "#1e1f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M74.262,427.019l-.01,0c-.119-.038-.237-.081-.352-.128l-.031-.011c-.037-.015-.072-.032-.107-.049a4.6,4.6,0,0,0,.5.192",
    transform: "translate(-56.26 -325.553)",
    fill: "#7183b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M75.835,427.626l-.009,0h0Z",
    transform: "translate(-57.834 -326.16)",
    fill: "#5363ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M73.869,426.876c-.037-.015-.072-.032-.107-.049.035.017.07.034.107.049",
    transform: "translate(-56.26 -325.553)",
    fill: "#5653ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M74.243,427.046l-.031-.011Z",
    transform: "translate(-56.604 -325.712)",
    fill: "#5653ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M74.243,427.046l-.031-.011Z",
    transform: "translate(-56.604 -325.712)",
    fill: "#393e48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M79.052,428.34Zm0,0h0",
    transform: "translate(-60.28 -326.706)",
    fill: "#5c8bd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M79.03,428.338Zm0,0h0",
    transform: "translate(-60.259 -326.705)",
    fill: "#212224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M74.765,399.631c.074-.906.138-1.818.306-2.838-.033.2-.06.391-.085.582-.006.047-.013.095-.019.141q-.037.286-.066.564c-.006.054-.01.107-.016.16q-.019.2-.037.39c-.03.337-.056.668-.083,1",
    transform: "translate(-57.025 -302.645)",
    fill: "#5c8bd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M93.015,393.718h0c.234-.46.475-.925.724-1.4-.25.476-.49.941-.724,1.4",
    transform: "translate(-70.945 -299.231)",
    fill: "#6154b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M79,428.337Z",
    transform: "translate(-60.258 -326.705)",
    fill: "#7a7b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M79,428.337Z",
    transform: "translate(-60.259 -326.705)",
    fill: "#1b1b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M78.948,428.337Z",
    transform: "translate(-60.216 -326.705)",
    fill: "#7a7b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M73.764,385.961h-.027l-1.418-.442c-.022-.011-.045-.02-.066-.031a.288.288,0,0,1-.154-.255.279.279,0,0,1,.011-.077,18.826,18.826,0,0,0,.622-3.841c.027-.331.053-.662.083-1q.017-.194.037-.39c.005-.054.01-.107.016-.16q.029-.278.066-.564c.006-.047.012-.094.019-.141.026-.191.053-.384.086-.582l.007-.042c.044-.262.1-.534.156-.811.018-.084.034-.167.054-.253.119-.518.226-1.044.334-1.571.081-.4.162-.791.249-1.185.029-.134.061-.266.092-.4.017-.072.032-.144.05-.215q.04-.167.082-.332c.076-.3.16-.594.25-.886h0v0q.583.059,1.165.131v0l.2.023h0a.818.818,0,0,1,.693.641l0,.013,0,.008v.005l0,.01v0a18.554,18.554,0,0,0,1.4,3.8c-.249.476-.491.941-.724,1.4l-.185-.644a9.117,9.117,0,0,0-1.006-2.525,3.754,3.754,0,0,0-.784-.867L73.4,382.82a3.643,3.643,0,0,0-.09,1.63,1.347,1.347,0,0,0,.854.958l-.008.023c-.041.114-.083.226-.124.343a.285.285,0,0,1-.271.188",
    transform: "translate(-54.992 -284.328)",
    fill: "#16121a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M74.431,426.916h0c-.081-.011-.163-.028-.245-.045H74.18c-.037-.007-.073-.012-.11-.02h0l-.028-.007c-.093-.022-.185-.048-.276-.076l-.046-.013-.006,0-.009,0a4.587,4.587,0,0,1-.5-.192l-.085-.042-.044-.02-.046-.022,1.418.442Z",
    transform: "translate(-55.699 -325.283)",
    fill: "#212224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M78.948,428.339",
    transform: "translate(-60.216 -326.706)",
    fill: "#644fc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M78.948,428.339",
    transform: "translate(-60.216 -326.706)",
    fill: "#444145"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M73.263,426.586l-.044-.02.044.02",
    transform: "translate(-55.846 -325.354)",
    fill: "#00000d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M78.948,428.337Z",
    transform: "translate(-60.216 -326.705)",
    fill: "#72698c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M78.947,428.337m.013,0h0",
    transform: "translate(-60.215 -326.705)",
    fill: "#5741d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M78.948,428.337Z",
    transform: "translate(-60.216 -326.705)",
    fill: "#504a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M78.947,428.337m.013,0h0",
    transform: "translate(-60.215 -326.705)",
    fill: "#46334b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M117.688,429.119l1.155,3.393,1.817-.953a5.859,5.859,0,0,1-1.486-2.794Z",
    transform: "translate(-89.764 -327.031)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M37.949,345.186a33.178,33.178,0,0,0-1.241-4.425,2.8,2.8,0,0,0-1.387-1.6,36.451,36.451,0,0,0-6.53-2.712,36.645,36.645,0,0,1-5.925-1.68,7.654,7.654,0,0,0-4.375-.455c-1.451.271-2.963.527-4.232.844a8.11,8.11,0,0,0,.095,3.738,5.664,5.664,0,0,0,2.075,3.066A6.739,6.739,0,0,0,19.7,343.08a26.917,26.917,0,0,0,3.49.012,53.21,53.21,0,0,1,8.246.4.818.818,0,0,1,.693.641,32.229,32.229,0,0,0,2.452,6.061c1.27,2.847,2.753,4.221,3.853,7.071a.294.294,0,0,0,.321.184,4.591,4.591,0,0,0,1.5-.517.293.293,0,0,0,.139-.344,71.965,71.965,0,0,1-2.436-11.406",
    transform: "translate(-10.745 -254.891)",
    fill: "#3e29a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M126.152,438.979a1.265,1.265,0,0,0-.807-.426c-.307-.052-.621-.042-.931-.073a3.456,3.456,0,0,1-2.272-1.207c-.144-.172-.3-.373-.519-.4-.328-.034-.537.324-.782.546a3.5,3.5,0,0,1-1.024.5.585.585,0,0,1-.3.024c-.244-.024-.446-.048-.446.777,0,1.15.564.971.564.971s.724.019,1.087.02c1.156.005,2.311.035,3.466.072a10.537,10.537,0,0,0,1.733.061.6.6,0,0,0,.228-.872",
    transform: "translate(-90.82 -333.217)",
    fill: "#412a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M126.421,447.319c-.068.173-.193.3-.284.3a10.53,10.53,0,0,1-1.733-.061c-1.155-.037-2.31-.067-3.466-.072-.364,0-1.087-.02-1.087-.02s-.349.108-.5-.406Z",
    transform: "translate(-91.035 -340.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M119.077,442.115c.008-.854.246-.746.516-.728a.945.945,0,0,1-.21.492.932.932,0,0,1-.306.237",
    transform: "translate(-90.823 -336.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M140.384,443.413c-.067,0-.134-.009-.2-.016.067.007.135.011.2.015h0m-.2-.016a3.334,3.334,0,0,1-.436-.075h.012a3.362,3.362,0,0,0,.423.075",
    transform: "translate(-106.59 -338.134)",
    fill: "#5692fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M129.592,439.7a3.663,3.663,0,0,1-2.791-1.275c.049-.049.1-.1.145-.154a3.6,3.6,0,0,0,2.717,1.205h0q.1,0,.208-.006a3.334,3.334,0,0,0,.436.075c.067.007.133.012.2.016a2.15,2.15,0,0,1-.52.118,3.7,3.7,0,0,1-.4.021",
    transform: "translate(-96.715 -334.281)",
    fill: "#271c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M128.657,438.11a3.707,3.707,0,0,1-1.248-.905c.168-.181.34-.352.572-.328s.376.224.519.4a3.457,3.457,0,0,0,1.849,1.132,3.717,3.717,0,0,1-1.692-.294",
    transform: "translate(-97.178 -333.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M121.3,441.433l-.055,0h0l.055,0h0Z",
    transform: "translate(-92.481 -336.692)",
    fill: "#5692fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M121.5,441.4h0a.486.486,0,0,0,.108-.012h0a.488.488,0,0,1-.108.012",
    transform: "translate(-92.668 -336.661)",
    fill: "#7068c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M119.075,442.23l0-.058v-.043a.932.932,0,0,0,.306-.237.944.944,0,0,0,.21-.491l.055,0h0a.492.492,0,0,0,.108-.012,2.022,2.022,0,0,1-.168.513.7.7,0,0,1-.512.325",
    transform: "translate(-90.82 -336.662)",
    fill: "#271c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M127.253,436.575c-.066-.1-.137-.224-.211-.359h0c.074.135.144.254.211.359h0",
    transform: "translate(-96.899 -332.714)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M121.039,437.457l-.142-.416a1.968,1.968,0,0,0,1.458-.822c.074.135.144.254.211.359-.042.04-.083.083-.124.127s-.1.105-.145.154h0c-.022.022-.043.043-.065.063s-.049.043-.075.063a4.3,4.3,0,0,1-.949.44.424.424,0,0,1-.17.031",
    transform: "translate(-92.212 -332.717)",
    fill: "#9aa4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M126.21,439.046c.026-.02.051-.041.075-.063s.043-.041.065-.063h0c-.022.022-.043.043-.065.063s-.049.043-.075.063",
    transform: "translate(-96.264 -334.777)",
    fill: "#3a3449"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M126.8,438.422h0c.049-.049.1-.1.145-.154h0c-.048.052-.1.105-.145.154",
    transform: "translate(-96.712 -334.279)",
    fill: "#5363ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M126.8,438.424h0c.049-.049.1-.1.145-.154h0c-.048.052-.1.105-.145.154",
    transform: "translate(-96.715 -334.28)",
    fill: "#1c1e23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M127.41,437.856h0c.041-.044.082-.087.124-.127h0c-.042.04-.083.084-.124.128",
    transform: "translate(-97.178 -333.867)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M124.477,430.317q-.048-.13-.1-.269h0c.033.094.065.182.1.269h0",
    transform: "translate(-94.868 -328.009)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M118.472,430.915l-.121-.354a4.618,4.618,0,0,0,1.42-.505l.01-.006q.048.139.1.269a3.293,3.293,0,0,1-1.407.6",
    transform: "translate(-90.27 -328.011)",
    fill: "#9aa4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M120.834,430.412a4.534,4.534,0,0,0,.821-.353l.01-.006.011-.007h0l-.01.006a4.529,4.529,0,0,1-.831.359",
    transform: "translate(-92.164 -328.009)",
    fill: "#312b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M116.346,428.268h0a.306.306,0,0,0,.047,0l.075-.012-.074.012a.308.308,0,0,1-.047,0m-.263-.161a.258.258,0,0,1-.012-.026c-.062-.161-.126-.318-.191-.47q.1.229.191.471c0,.009.007.018.012.026m1.956-.631a.285.285,0,0,0-.013-.072q-.06-.191-.118-.38h0c.039.127.076.252.117.38a.285.285,0,0,1,.013.072",
    transform: "translate(-88.386 -325.703)",
    fill: "#5692fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M86.535,373.353h0l-.2-.025.2.025",
    transform: "translate(-65.847 -284.748)",
    fill: "#19151d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M64.208,371.907a53.168,53.168,0,0,0-5.351-.27,53.168,53.168,0,0,1,5.351.27",
    transform: "translate(-44.892 -283.458)",
    fill: "#6f7d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M81.41,372.776",
    transform: "translate(-62.094 -284.327)",
    fill: "#260f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M81.412,372.776h0",
    transform: "translate(-62.093 -284.327)",
    fill: "#19151d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M18.508,357.73h0a5.441,5.441,0,0,1-1.233-.655,5.664,5.664,0,0,1-2.075-3.066l0-.014,0,.014a5.664,5.664,0,0,0,2.075,3.066,5.441,5.441,0,0,0,1.233.655",
    transform: "translate(-11.59 -270.002)",
    fill: "#5692fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M15.107,353.671l0-.014,0,.014m0-.014,0-.013,0,.013m0-.014,0-.013,0,.013m0-.014,0-.012,0,.012m0-.014,0-.012,0,.012m0-.014,0-.012,0,.012m0-.014,0-.011,0,.011m0-.014h0",
    transform: "translate(-11.502 -269.679)",
    fill: "#5692fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M15.061,353.5l0-.01,0,.01m0-.014,0-.008,0,.008",
    transform: "translate(-11.483 -269.61)",
    fill: "#6f7d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M83.493,373.612v0m0-.012v0m0-.013,0-.013a.818.818,0,0,0-.693-.641h0a.818.818,0,0,1,.693.641l0,.013m-.9-.68q-.582-.072-1.164-.131.583.059,1.164.131",
    transform: "translate(-62.104 -284.328)",
    fill: "#000019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M118.35,432.2Z",
    transform: "translate(-90.269 -329.654)",
    fill: "#7068c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M38.709,361.7a.293.293,0,0,1-.263-.161c0-.008-.008-.017-.012-.026q-.093-.242-.191-.47c-1.063-2.508-2.43-3.88-3.618-6.5l-.045-.1a32.625,32.625,0,0,1-2.444-6.023v0s0-.006,0-.01V348.4l0-.008,0-.013a.818.818,0,0,0-.693-.641l-.2-.025q-.582-.072-1.165-.131h0a53.181,53.181,0,0,0-5.351-.27q-.3,0-.6,0-.334,0-.668.012l-.26.007h-.053l-.234.007h-.019c-.581.019-1.163.043-1.745.043h0c-.472,0-.944-.016-1.414-.062H19.7l-.016,0h0a7.928,7.928,0,0,1-2.017-.459,5.443,5.443,0,0,1-1.233-.655,5.664,5.664,0,0,1-2.075-3.066l0-.014h0l0-.014h0l0-.013h0l0-.013h0l0-.012v0l0-.012v0l0-.012v0l0-.011v0h0l0-.01v0l0-.008a8.025,8.025,0,0,1-.116-3.259,5.647,5.647,0,0,0,2.607,4.722,10.972,10.972,0,0,0,5.755,1.589c.356.014.712.019,1.068.019.615,0,1.23-.016,1.845-.033s1.23-.032,1.845-.032c.43,0,.86.008,1.289.029a6.018,6.018,0,0,1,3.114.821,7.041,7.041,0,0,1,2.142,3.02l4.185,8.927a3.728,3.728,0,0,0,.929,1.388,1.479,1.479,0,0,0,.9.325,1.1,1.1,0,0,0,.383-.066q.058.189.118.38a.285.285,0,0,1,.013.072.3.3,0,0,1-.141.265v0l-.01.009-.01.006a4.6,4.6,0,0,1-1.411.5v0l-.075.012a.306.306,0,0,1-.047,0",
    transform: "translate(-10.749 -259.133)",
    fill: "#260f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M118.35,431.733h0a4.533,4.533,0,0,0,.589-.146,4.5,4.5,0,0,1-.589.146",
    transform: "translate(-90.269 -329.184)",
    fill: "#5363ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M118.348,430.553v0a4.6,4.6,0,0,0,1.411-.5,4.62,4.62,0,0,1-1.41.5m1.421-.505h0l.01-.009v0l-.011.007",
    transform: "translate(-90.267 -328.003)",
    fill: "#1e1f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M19.975,201.056a5.337,5.337,0,0,0-4.041-1.685,5.529,5.529,0,0,0-2.683.657,2.649,2.649,0,0,1,3.107.77,2.429,2.429,0,0,1,3.01,2.007v5.981l-2.585,1.235.424.5v1.235l3.627.663v-9.166a3.22,3.22,0,0,0-.86-2.2",
    transform: "translate(-10.107 -152.066)",
    fill: "#6059ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M19.255,240.524c.032,1.547.228,3.07-.508,4.027l5.407,2.543a10.435,10.435,0,0,1-2.292-2.681,3.537,3.537,0,0,1-.089-3.391Z",
    transform: "translate(-14.299 -183.454)",
    fill: "#d2cbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M4.576,201.158a2.532,2.532,0,0,0-1.06.439,5.731,5.731,0,0,0-2.375,4.551v3.784a2.339,2.339,0,0,0,1.706,2.251l2.963.832v-9.029a1.76,1.76,0,0,0,1.312-1.929,2.525,2.525,0,0,0-2.546-.9",
    transform: "translate(-0.87 -153.396)",
    fill: "#6059ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M19.285,275.1c-1.395-3.02-.876-5.834.855-8.674a3.392,3.392,0,0,0,1.767-1.138,2.857,2.857,0,0,0,.563-1.538.7.7,0,0,0-.171-.5,31.891,31.891,0,0,0-5.922-5.754,5.345,5.345,0,0,0-1.858-.873,2.333,2.333,0,0,0-1.956.4,3.5,3.5,0,0,0-.919,2.491,92.463,92.463,0,0,0,.628,16.445,18.1,18.1,0,0,0,3.507-.432,18.093,18.093,0,0,1,3.507-.432",
    transform: "translate(-8.755 -195.693)",
    fill: "#5f64ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M20.476,269.194a1.421,1.421,0,0,0,1.276.224l.211.267a1.609,1.609,0,0,1-1.722-.149,2.1,2.1,0,0,1-.78-1.647,2.975,2.975,0,0,1,.5-1.614,1.681,1.681,0,0,0,.024.558,2.429,2.429,0,0,0-.19.931,1.816,1.816,0,0,0,.677,1.429",
    transform: "translate(-14.843 -203.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M21.14,268.86a3.835,3.835,0,0,0,.832,1.265l.869,1.088a1.421,1.421,0,0,1-1.276-.224,1.816,1.816,0,0,1-.677-1.429,2.425,2.425,0,0,1,.19-.931,1.635,1.635,0,0,0,.062.231",
    transform: "translate(-15.932 -204.891)",
    fill: "#d2cbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M41.7,274.69V275.8l-11.074-1.612a1.619,1.619,0,0,1-1.265-.608l-5.824-7.3-.211-.267-.869-1.088a3.832,3.832,0,0,1-.832-1.265,1.793,1.793,0,0,1-.086-.789,1.215,1.215,0,0,1,.332-.715,1.461,1.461,0,0,1,1.47-.259,2.842,2.842,0,0,1,.522.231,3.569,3.569,0,0,1,1.123,1.039l5.6,7.818a1.622,1.622,0,0,0,1.086.659Z",
    transform: "translate(-16.422 -199.684)",
    fill: "#d2cbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M13.651,211.484a3.571,3.571,0,0,0,1.814,2.977,3.745,3.745,0,0,0,2.956.206,1.415,1.415,0,0,0,.844-.852,11.537,11.537,0,0,0,.277-7.185c-.365-1.261-2.072-1.848-3.364-1.61a3.779,3.779,0,0,0-2.785,2.519c-.419,1.244.224,2.633.258,3.945",
    transform: "translate(-10.107 -156.335)",
    fill: "#d2cbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M4.015,201.588a5.689,5.689,0,0,0-2.874,4.861v3.785a2.338,2.338,0,0,0,1.706,2.251l3.2,1.058-.232-9.255a1.76,1.76,0,0,0,1.312-1.929,2.648,2.648,0,0,0-3.107-.77",
    transform: "translate(-0.87 -153.626)",
    fill: "#6059ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M25.186,237.524a1.463,1.463,0,0,0,2.889,0Z",
    transform: "translate(-19.21 -181.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M36.932,224.671a.471.471,0,0,0,.41-.366.689.689,0,0,0-.18-.523,1.335,1.335,0,0,1-.216-.628,1.179,1.179,0,0,1,.123-.638,1.656,1.656,0,0,0,.244,1.171,1.591,1.591,0,0,1,.157.3.544.544,0,0,1,.005.36.482.482,0,0,1-.543.329",
    transform: "translate(-28.169 -169.719)",
    fill: "#7289f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M26.631,238.882c-1.184,0-1.444-1.358-1.444-1.358a1.462,1.462,0,0,0,2.889,0s-.261,1.358-1.445,1.358",
    transform: "translate(-19.211 -181.166)",
    fill: "#95baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M27.451,206.789a4.86,4.86,0,0,0-.467-3.226,3.448,3.448,0,0,0-2.652-1.778,1.651,1.651,0,0,0-.975.184.888.888,0,0,0-.452.838c.091.679.756.452,1.207.546a4.2,4.2,0,0,1,1.525.691,4.421,4.421,0,0,1,1.814,2.745",
    transform: "translate(-17.465 -153.902)",
    fill: "#6059ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M23.627,273.258l-.421-.774a4.911,4.911,0,0,1-.4-1.015,5.588,5.588,0,0,0,.628.822l.682.854Z",
    transform: "translate(-17.397 -207.057)",
    fill: "#8fb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M23.437,272.284a5.6,5.6,0,0,1-.628-.822v0a5.6,5.6,0,0,0,.628.825",
    transform: "translate(-17.397 -207.05)",
    fill: "#8fb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M43.337,302.621l0-.007a11.968,11.968,0,0,1,.7-1.544l0,0a11.992,11.992,0,0,0-.7,1.548",
    transform: "translate(-33.051 -229.635)",
    fill: "#ff9857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M31.164,286.186l-3.723-6.214A1.418,1.418,0,0,0,28,279.8l3.864,4.846a11.966,11.966,0,0,0-.7,1.544m-3.784-6.592h0m0,0a1.311,1.311,0,0,0,.4-.062,1.3,1.3,0,0,1-.4.062",
    transform: "translate(-20.883 -213.206)",
    fill: "#5b4dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M26.893,279.964l-.233-.389a1.371,1.371,0,0,0,.171.011h0a1.3,1.3,0,0,0,.4-.062l.008,0,.211.267a1.419,1.419,0,0,1-.561.177",
    transform: "translate(-20.334 -213.199)",
    fill: "#ff9857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M26.525,279.2h0a1.371,1.371,0,0,1-.171-.011l0,0-.094-.172.094.172a1.452,1.452,0,0,0,.182.011,1.285,1.285,0,0,0,.4-.063l-.008,0a1.311,1.311,0,0,1-.4.062Z",
    transform: "translate(-20.027 -212.809)",
    fill: "#6c9aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M28.517,278.768l-.187-.234Z",
    transform: "translate(-21.608 -212.446)",
    fill: "#6c9aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M26.532,278.831a1.458,1.458,0,0,1-.182-.011l-.094-.173.492-.113.187.234a1.285,1.285,0,0,1-.4.063",
    transform: "translate(-20.027 -212.446)",
    fill: "#6d91ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M60.444,305.736l-.51-.074-10.41-1.515a1.618,1.618,0,0,1-1.265-.608L46.3,301.083l1.957,2.456a1.618,1.618,0,0,0,1.265.608l10.914,1.589Zm-.08-.012h0",
    transform: "translate(-35.315 -229.645)",
    fill: "#e6e2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M47.439,289.425l-10.914-1.589a1.618,1.618,0,0,1-1.265-.608L33.3,284.774l-3.866-4.849-.177-.224,6.21,6.554a1.971,1.971,0,0,0,1.032.574l9.965,2.055a.365.365,0,0,0,.434-.3l.074-.437.406.124-.187,1.11Z",
    transform: "translate(-22.317 -213.335)",
    fill: "#8fb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M46.293,301.073l0,0Z",
    transform: "translate(-35.307 -229.635)",
    fill: "#8f8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M33.87,285.492l-3.863-4.846Z",
    transform: "translate(-22.887 -214.057)",
    fill: "#4b56f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M33.873,285.5l0,0-3.864-4.846Z",
    transform: "translate(-22.887 -214.057)",
    fill: "#6d91ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M63.952,341.217h0Zm-.007,0h0m-.007,0-.007,0,.007,0m-6.628-2.736h0m-.008,0a36.931,36.931,0,0,1-5.7-1.6l-.005-.005a36.885,36.885,0,0,0,5.705,1.61",
    transform: "translate(-39.355 -256.934)",
    fill: "#5692fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M65.3,342.721c-2.976-1.12-5.744-2.976-8.821-3.874-.887-.259-1.8-.437-2.672-.734a5.89,5.89,0,0,1-2.183-1.23,36.938,36.938,0,0,0,5.7,1.6h.008l.09.021a36.455,36.455,0,0,1,6.53,2.712l.007,0,0,0h0l.007,0h0a2.8,2.8,0,0,1,1.326,1.488",
    transform: "translate(-39.371 -256.95)",
    fill: "#260f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M110.322,303.293a.168.168,0,0,1-.188-.126l-.11-.45a.168.168,0,1,1,.326-.08l.11.45a.168.168,0,0,1-.123.2Z",
    transform: "translate(-83.914 -230.732)",
    fill: "#b9c5ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M110.028,302.094a.168.168,0,0,1-.188-.126l-.057-.233a.168.168,0,0,1,.326-.08l.057.233a.168.168,0,0,1-.123.2Z",
    transform: "translate(-83.731 -229.983)",
    fill: "#5e95ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M115.572,325.47l.275.445.034-.526Z",
    transform: "translate(-88.15 -248.183)",
    fill: "#d2cbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M111.857,309.544a.168.168,0,0,1-.188-.126l-1.181-4.8a.168.168,0,0,1,.326-.08l1.181,4.8a.168.168,0,0,1-.123.2Z",
    transform: "translate(-84.268 -232.182)",
    fill: "#8cd6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M116.549,327.154l-.026,0-.04.012.059.1Z",
    transform: "translate(-88.845 -249.528)",
    fill: "#4038b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M108.181,312.469l.173-1.027a.221.221,0,0,0-.181-.255l-2.11-.355a.827.827,0,0,0-.952.678l-.271,1.61,1.962.331a1.2,1.2,0,0,0,1.379-.981",
    transform: "translate(-79.964 -237.071)",
    fill: "#d2cbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M113.347,314.66a1.2,1.2,0,0,1-.2-.017h0a1.2,1.2,0,0,0,.345.006v0a1.209,1.209,0,0,1-.145.009m.469-.1v0a1.2,1.2,0,0,0,.7-.9l.173-1.027a.221.221,0,0,0-.164-.251.219.219,0,0,1,.165.249l-.175,1.04a1.185,1.185,0,0,1-.7.892",
    transform: "translate(-86.3 -238.263)",
    fill: "#b9d3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M118.278,312.264h0Z",
    transform: "translate(-90.208 -238.172)",
    fill: "#b9d3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M114.6,321.65v0a1.192,1.192,0,0,0,.323-.09v0a1.187,1.187,0,0,1-.324.088",
    transform: "translate(-87.409 -245.261)",
    fill: "#72c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M107,314.568a1.2,1.2,0,0,1-.192-.015l-1.971-.332.058-.341,1.608.271a1.2,1.2,0,0,0,.2.017,1.186,1.186,0,0,0,1.168-.989l.154-.914h.008l.141.024.015,0a.221.221,0,0,1,.164.251l-.173,1.027a1.194,1.194,0,0,1-1.179,1",
    transform: "translate(-79.964 -238.172)",
    fill: "#8fb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M70.187,428.216a1.922,1.922,0,0,0,1.623.214,9.045,9.045,0,0,1,.284-1.247,3.212,3.212,0,0,1-1.45-.361l.115-.35-.705,2.151Z",
    transform: "translate(-53.431 -325.283)",
    fill: "#b2b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M75.972,436.564l.134-.023-.134.023",
    transform: "translate(-57.946 -332.962)",
    fill: "#d5e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M77.261,435.273c0-.06.011-.123.018-.19v0c.006-.054.013-.109.021-.167v0c-.008.057-.015.111-.021.164v0c-.007.066-.014.13-.018.19",
    transform: "translate(-58.929 -331.721)",
    fill: "#6c83ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M77.338,435.621h0v0Z",
    transform: "translate(-58.988 -332.259)",
    fill: "#9aa4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M77.447,434.762v0",
    transform: "translate(-59.071 -331.599)",
    fill: "#b4bdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M77.427,434.82v0l0-.03,0,.034",
    transform: "translate(-59.056 -331.624)",
    fill: "#6577fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M71.194,434.517c-.041,0-.081,0-.121-.006a1.948,1.948,0,0,1-.262-.042c-.079-.018-.157-.039-.235-.061-.123-.035-.247-.073-.371-.1a.343.343,0,0,1-.071-.027l-.034-.019-.041-.026-.005,0,.134-.408a1.959,1.959,0,0,0,.8.29l.029,0a1.9,1.9,0,0,0,.205.011h0a2,2,0,0,0,.587-.09v.014l0,.03c-.008.058-.015.114-.021.167v0c-.007.066-.014.13-.018.19l-.1.014-.072.013-.134.023c-.053.009-.107.019-.158.024h-.027l-.079,0Z",
    transform: "translate(-53.432 -330.888)",
    fill: "#9aa4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M74.215,434.815h0Zm0,0a2.008,2.008,0,0,0,.587-.09,2.007,2.007,0,0,1-.587.09m-.208-.011-.029,0,.029,0",
    transform: "translate(-56.427 -331.577)",
    fill: "#9aa4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M73.992,427.184a3.212,3.212,0,0,1-1.45-.361l.115-.35h0q.086.043.175.084c.035.017.07.034.107.049l.031.011c.115.048.233.09.353.128l.018.006.031.009.019.005c.094.028.189.056.284.078l.01,0,.014,0,.007,0c.12.027.239.049.358.065h.013c-.03.093-.057.181-.083.269",
    transform: "translate(-55.33 -325.283)",
    fill: "#9aa4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M77.417,428.06l-.007,0h.007",
    transform: "translate(-59.043 -326.492)",
    fill: "#1b2235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M75.936,427.657l-.031-.009.006,0Z",
    transform: "translate(-57.895 -326.179)",
    fill: "#312b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M77.366,428.05l-.014,0,.013,0h0",
    transform: "translate(-58.999 -326.484)",
    fill: "#563ecd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M77.408,428.057h0",
    transform: "translate(-59.041 -326.491)",
    fill: "#00061f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M75.846,427.63l-.018-.006.01,0,.009,0",
    transform: "translate(-57.836 -326.161)",
    fill: "#563ecd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M76.238,427.738h0m-.355-.1-.006,0-.009,0,.009,0,.006,0",
    transform: "translate(-57.867 -326.171)",
    fill: "#1b1b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M73.072,426.5l-.046-.022h0l.046.022",
    transform: "translate(-55.699 -325.283)",
    fill: "#00001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M73.2,426.558c-.059-.027-.117-.055-.175-.084l.046.022.044.02.085.042",
    transform: "translate(-55.699 -325.284)",
    fill: "#00001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M568.285,187.882h-.062a1.334,1.334,0,0,0,.967-.446,1.838,1.838,0,0,0,.54-.911s-.261,1.358-1.444,1.358m-1.409-1.234h0c-.022-.077-.031-.124-.031-.124s.01.048.035.124",
    transform: "translate(-432.345 -142.267)",
    fill: "#95baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M568.324,188.281a1.564,1.564,0,0,1-1.351-1.233h0a1.493,1.493,0,0,0,1.409,1.11,1.342,1.342,0,0,0,.9-.323,1.334,1.334,0,0,1-.967.446",
    transform: "translate(-432.446 -142.667)",
    fill: "#f0ecea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M268.339,116.862H209.382v-.722H267.6v-5.695h.738Zm0-8.592H267.6V78.532h.168a.559.559,0,0,0,.559-.559v-.335a.611.611,0,0,0,0-.066h.015v28.152a.5.5,0,0,0-.047.213V107.1a.5.5,0,0,0,.047.213v.957",
    transform: "translate(-159.702 -59.166)",
    fill: "#ffc3b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 0.738,
    height: 2.176,
    transform: "translate(107.899 49.105)",
    fill: "#97beff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M457.712,197.809a.5.5,0,0,1-.047-.213v-1.165a.5.5,0,0,1,.047-.213Z",
    transform: "translate(-349.074 -149.662)",
    fill: "#97beff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M263.058,76.947H203.765a.559.559,0,0,1-.559-.559v-.336a.559.559,0,0,1,.559-.559h59.293a.559.559,0,0,1,.559.559v.336a.559.559,0,0,1-.559.559",
    transform: "translate(-154.991 -57.581)",
    fill: "#4038b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 58.957,
    height: 37.608,
    transform: "translate(48.942 19.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M265.228,119.229H206.271V81.621h1.678V116.3A1.052,1.052,0,0,0,209,117.348h56.228Z",
    transform: "translate(-157.329 -62.255)",
    fill: "#d3e3e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M212.39,18.639V0h-.237v18.64",
    transform: "translate(-161.815 0)",
    fill: "#4038b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M448.105,18.639V0h-.237v18.64",
    transform: "translate(-341.602 0)",
    fill: "#4038b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M88.525,74.157a7.506,7.506,0,1,0-15.012,0Z",
    transform: "translate(-56.07 -50.837)",
    fill: "#5f7eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M73.512,97.564v0Zm0-.014v0m0-.011v0m0-.011v0m0-.014v0m0-.012v0m0-.011v0m0-.013v0m0-.012v0m0-.012v0m0-.013v0m0-.014v0m0-.011v0m0-.026v0m0-.011v0m0-.01v0m0-.017v0m0-.01v0",
    transform: "translate(-56.07 -74.243)",
    fill: "#a2b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M74.484,75.768h-.971v-.123s0-.005,0-.008v-.021c0-.007,0-.014,0-.022v-.041s0-.005,0-.008v0a7.508,7.508,0,0,1,4.806-6.78A10.663,10.663,0,0,0,75.3,72.241a5.921,5.921,0,0,0-.814,3.527",
    transform: "translate(-56.07 -52.447)",
    fill: "#635ee7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M88.715,74.2H86.539a11.573,11.573,0,0,1,3.371-7.432c.115-.016.231-.03.347-.041h0l.082-.006q.112-.009.226-.015a6.479,6.479,0,0,0-1.308,2.458,15.426,15.426,0,0,0-.512,3.15,10.4,10.4,0,0,0-.029,1.887",
    transform: "translate(-66.006 -50.876)",
    fill: "#c0d7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M313.887,74.157a7.506,7.506,0,1,0-15.012,0Z",
    transform: "translate(-227.96 -50.837)",
    fill: "#5f7eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M298.875,97.563v0m0-.014v0m0-.011v0m0-.011v0m0-.014v0m0-.012v0m0-.011v0m0-.013v0m0-.012s0,0,0-.007,0,0,0,.007m0-.012v0m0-.012v0m0-.014v0m0-.011v0m0-.026v0m0-.011v0m0-.011v0m0-.018h0m0-.01h0",
    transform: "translate(-227.96 -74.243)",
    fill: "#a2b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M299.846,75.768h-.971v-.1s0,0,0-.007v-.046c0-.007,0-.014,0-.022v-.023c0-.005,0-.011,0-.016v0s0-.005,0-.008h0a7.508,7.508,0,0,1,4.806-6.781,10.66,10.66,0,0,0-3.025,3.478,5.921,5.921,0,0,0-.814,3.527",
    transform: "translate(-227.96 -52.447)",
    fill: "#635ee7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M314.078,74.2H311.9a11.574,11.574,0,0,1,3.371-7.432c.115-.016.231-.03.347-.041h0l.082-.006c.075-.006.15-.011.225-.015a6.482,6.482,0,0,0-1.308,2.458,15.441,15.441,0,0,0-.512,3.15,10.4,10.4,0,0,0-.029,1.887",
    transform: "translate(-237.897 -50.876)",
    fill: "#c0d7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M539.25,74.157a7.506,7.506,0,1,0-15.012,0Z",
    transform: "translate(-399.851 -50.837)",
    fill: "#5f7eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M524.238,97.563v0Zm0-.014v0m0-.011v0m0-.011v0m0-.014v0m0-.012v0m0-.011s0-.007,0-.01,0,.007,0,.01m0-.013v0m0-.012v0m0-.012v0m0-.012s0-.006,0-.009,0,.005,0,.009m0-.014v0m0-.011v0m0-.026v0m0-.011v0m0-.011v0m0-.018h0m0-.01h0",
    transform: "translate(-399.851 -74.243)",
    fill: "#a2b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M525.209,75.768h-.971v-.074s0-.007,0-.01v-.039s0-.005,0-.008v-.021c0-.007,0-.014,0-.022v-.023c0-.005,0-.011,0-.016v0s0-.005,0-.008h0a7.507,7.507,0,0,1,4.806-6.781,10.663,10.663,0,0,0-3.024,3.478,5.921,5.921,0,0,0-.814,3.527",
    transform: "translate(-399.851 -52.447)",
    fill: "#635ee7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M539.44,74.2h-2.176a11.575,11.575,0,0,1,3.371-7.432c.115-.016.231-.03.348-.041h0l.082-.006q.112-.009.225-.015a6.483,6.483,0,0,0-1.308,2.458,15.439,15.439,0,0,0-.512,3.15,10.369,10.369,0,0,0-.029,1.887",
    transform: "translate(-409.787 -50.876)",
    fill: "#c0d7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M104.351,15.819c.063,0,.125,0,.188,0,.24,0,.477.012.711.034.026-.947.039-4.18.014-15.849h-.914c.014,7.986.022,14.551,0,15.819",
    transform: "translate(-79.591)",
    fill: "#5f7eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M102.715,0h-.508c.008,4.7.015,8.909.014,11.827v.14c0,.09,0,.175,0,.263v.307c0,.033,0,.065,0,.1,0,1.651,0,2.786-.013,3.213l.082-.006-.054-.018.054.018q.212-.017.428-.023c.021-1.268.013-7.833,0-15.819",
    transform: "translate(-77.956)",
    fill: "#5f7eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M102.207,15.847c.008-.427.012-1.562.013-3.213,0-.033,0-.065,0-.1v-.307c0-.087,0-.173,0-.263v-.559c0-2.895-.006-6.926-.014-11.408h.508c.008,4.492.014,8.535.014,11.438,0,2.258,0,3.827-.013,4.381l-.2.008q-.113.006-.226.015l-.082.006",
    transform: "translate(-77.956 0.001)",
    fill: "#635ee7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M329.713,15.819c.063,0,.125,0,.188,0,.24,0,.477.012.711.034.026-.947.039-4.18.014-15.849h-.914c.014,7.986.023,14.551,0,15.819",
    transform: "translate(-251.481)",
    fill: "#5f7eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M328.078,0h-.508c.008,4.7.015,8.909.014,11.827v.71c0,.033,0,.065,0,.1,0,1.651-.005,2.786-.013,3.213l.082-.006-.054-.018.054.018q.212-.017.427-.023c.021-1.268.013-7.833,0-15.819",
    transform: "translate(-249.847)",
    fill: "#5f7eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M327.57,15.847c.008-.427.012-1.562.013-3.213,0-.033,0-.065,0-.1v-.71q0-.205,0-.419c0-2.895-.006-6.926-.014-11.408h.508c.008,4.492.014,8.535.014,11.438,0,2.258,0,3.827-.013,4.381l-.2.008c-.075,0-.15.009-.225.015l-.082.006",
    transform: "translate(-249.847 0.001)",
    fill: "#635ee7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M555.075,0c.014,7.986.022,14.551,0,15.819.063,0,.125,0,.188,0,.24,0,.477.012.711.034.026-.947.039-4.18.014-15.849Z",
    transform: "translate(-423.372)",
    fill: "#5f7eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M553.44,0h-.508c.008,4.7.015,8.909.014,11.827v.4c0,.1,0,.208,0,.307v.1c0,1.651-.005,2.786-.013,3.213l.082-.006-.054-.018.054.018q.212-.017.427-.023c.021-1.268.013-7.833,0-15.819",
    transform: "translate(-421.737)",
    fill: "#5f7eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M552.933,15.847c.008-.427.012-1.562.013-3.213v-.1c0-.1,0-.2,0-.307v-.893c0-2.89-.006-6.892-.014-11.337h.508c.008,4.492.014,8.535.014,11.438,0,2.258,0,3.827-.013,4.381l-.2.008q-.113.006-.225.015l-.082.006",
    transform: "translate(-421.737 0.001)",
    fill: "#635ee7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M520.75,324.32h-8.474v.78h7.993a.481.481,0,0,0,.481-.481Z",
    transform: "translate(-390.728 -247.368)",
    fill: "#5f5fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M443.978,286.606l2.15,9.338a.5.5,0,0,0,.49.39h13.649l-2.295-9.728Z",
    transform: "translate(-338.635 -218.603)",
    fill: "#e5f2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M458.1,284.178H444.721a.4.4,0,0,0-.281.116l-.463.46h13.995l2.295,9.728h.526l-2.3-10a.4.4,0,0,0-.388-.309",
    transform: "translate(-338.635 -216.751)",
    fill: "#83a6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M471.435,300.416a1.7,1.7,0,1,1-1.7-1.7,1.7,1.7,0,0,1,1.7,1.7",
    transform: "translate(-356.979 -227.837)",
    fill: "#83a6ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingroom);
export default __webpack_public_path__ + "static/media/meetingroom.b7c19595a1114e494668f8d50fe3d781.svg";
export { ForwardRef as ReactComponent };